'use strict';

import { ModalShowHide } from '../components/modal';
import Map from '../components/pickupPointMap';
import { getPosition } from 'product/findinstore';
import { woosmapInitInPost, woosmapInitPPL, woosmapInitDHL, woosmapInitDPD, woosmapInitBRT, woosmapInitHermes, woosmapListenerForModalClose, woosmapInitCollissimo, woosmapInitPudoBFF } from 'woosmap';

export class PickupPoint {
    constructor () {
        this.coordinates = {
            lat: 0,
            long: 0
        };
        this.wasMapInitialized = false;
        this.wasMapInitializedInPost = false;
        this.wasMapInitializedPPL = false;
        this.wasMapInitializedDHL = false;
        this.wasMapInitializedDPD = false;
        this.wasMapInitializedHermes = false;
        this.wasMapInitializedCLSS = false;
        this.wasMapInitializedBPOST = false;
        this.wasMapInitializedPDB = false;
        this.firstSearchLaunchedPDB = false;
        this.elementSelector = '#pickupPointMapModal';
        this.elementSelectorOSM = '#modalOSM';
        this.elementSelectorInPost = '#pickupPointInPost';
        this.elementSelectorBRT = '#pickupPointBRT';
        this.elementSelectorPPL = '#pickupPointPPL';
        this.elementSelectorDHL = '#pickupPointDHL';
        this.elementSelectorDPD = '#pickupPointDPD';
        this.elementSelectorCLSS = '#pickupPointCLSS';
        this.elementSelectorHermes = '#pickupPointHermes';
        this.elementSelectorBPOST = '#pickupPointBPOST';
        this.elementSelectorPDB = '#pickupPointPDB';
        this.radiusSelector = 'input[name="fis-radiuspick"]';
        this.btnSelector = '#pickupPointButton';
        this.btnSelectorInPost = '#pickupPointButtonIN';
        this.btnSelectorBRT = '#pickupPointButtonBRT';
        this.btnSelectorPPL = '#pickupPointButtonPPL';
        this.btnSelectorCLSS = '#pickupPointButtonCLSS';
        this.btnSelectorDHL = '#pickupPointButtonDHL';
        this.btnSelectorDPD = '#pickupPointButtonDPD';
        this.btnSelectorHermes = '#pickupPointButtonHermes';
        this.btnSelectorOSM = '#pickupPointButtonOSM';
        this.btnSelectorBPOST = '#pickupPointButtonBPOST';
        this.btnSelectorPDB = '#pickupPointButtonPDB';
        this.queryPPL = '';
        this.queryDPD = '';
        this.locality = '';
        this.zipcode = '';
        this.selectedShippingMethodId = '';
        this.selectedShippingMethodType = ''
        this.wasMapInitializedEVR = false;
        this.elementSelectorEVR = '#pickupPointEVR';
        this.btnSelectorEVR = '#pickupPointButtonEVR';
        this.wasMapInitializedPTN = false;
        this.elementSelectorPTN = '#pickupPointPTN';
        this.btnSelectorPTN = '#pickupPointButtonPTN';
        this.wasMapInitializedEST = false;
        this.elementSelectorEST = '#pickupPointEST';
        this.btnSelectorEST = '#pickupPointButtonEST';
        this.wasMapInitializedDEL = false;
        this.elementSelectorDEL = '#pickupPointDEL';
        this.btnSelectorDEL = '#pickupPointButtonDEL';
        this.wasMapInitializedCTT = false;
        this.elementSelectorCTT = '#pickupPointCTT';
        this.btnSelectorCTT = '#pickupPointButtonCTT';
        this.wasMapInitializedGLS = false;
        this.elementSelectorGLS = '#pickupPointGLS';
        this.btnSelectorGLS = '#pickupPointButtonGLS';
        this.wasMapInitializedMRE = false;
        this.elementSelectorMRE = '#pickupPointMRE';
        this.btnSelectorMRE = '#pickupPointButtonMRE';
        this.wasMapInitializedGLSHU = false;
        this.elementSelectorGLSHU = '#pickupPointGLSHU';
        this.btnSelectorGLSHU = '#pickupPointButtonGLSHU';
        this.wasMapInitializedDPD = false;
        this.elementSelectorDPD = '#pickupPointDPD';
        this.btnSelectorDPD = '#pickupPointButtonDPD';
        this.wasMapInitializedFAN = false;
        this.elementSelectorFAN = '#pickupPointFAN';
        this.btnSelectorFAN = '#pickupPointButtonFAN';
        this.wasMapInitializedXBS = false;
        this.elementSelectorXBS = '#pickupPointXBS';
        this.btnSelectorXBS = '#pickupPointButtonXBS';
        this.woosmapListenerPudoBFFInitialized = false;
    }

    run () {
        // Define elements from DOM
        this.$element = $(this.elementSelector);
        this.$elementInPost = $(this.elementSelectorInPost);
        this.$elementBRT = $(this.elementSelectorBRT);
        this.$elementPPL = $(this.elementSelectorPPL);
        this.$elementDHL = $(this.elementSelectorDHL);
        this.$elementCLSS = $(this.elementSelectorCLSS);
        this.$elementHermes = $(this.elementSelectorHermes);
        this.$elementBPOST = $(this.elementSelectorBPOST);
        this.$elementPDB = $(this.elementSelectorPDB);
        this.$elementEVR = $(this.elementSelectorEVR);
        this.$elementPTN = $(this.elementSelectorPTN);
        this.$elementEST = $(this.elementSelectorEST);
        this.$elementDEL = $(this.elementSelectorDEL);
        this.$elementCTT = $(this.elementSelectorCTT);
        this.$elementGLS = $(this.elementSelectorGLS);
        this.$elementMRE = $(this.elementSelectorMRE);
        this.$elementGLSHU = $(this.elementSelectorGLSHU);
        this.$elementDPD = $(this.elementSelectorDPD);
        this.$elementFAN = $(this.elementSelectorFAN);
        this.$elementXBS = $(this.elementSelectorXBS);
        this.countryCode = document.getElementById('country-code') && document.getElementById('country-code').value ? document.getElementById('country-code').value : null;
        this.addSearchListener();
        this.addSearchListener2();
        this.showPUPPopupListener();
        this.mapListener();
        this.observeViewMoreDHL();
        this.observeViewMoreDPD();
        this.observeViewMoreHermes();
        this.url = $(this.btnSelector).data('url');
        this.urlInpost = $(this.btnSelectorInPost).data('url');
        this.urlBRT = $(this.btnSelectorBRT).data('url');
        this.urlPPL = $(this.btnSelectorPPL).data('url');
        this.urlCLSS = $(this.btnSelectorCLSS).data('url');
        this.urlDHL = $(this.btnSelectorDHL).data('url');
        this.urlHermes = $(this.btnSelectorHermes).data('url');
        this.urlBPOST = $(this.btnSelectorBPOST).data('url');
        this.urlPDB = $(this.btnSelectorPDB).data('url');
        this.urlEVR = $(this.btnSelectorEVR).data('url');
        this.urlPTN = $(this.btnSelectorPTN).data('url');
        this.urlEST = $(this.btnSelectorEST).data('url');
        this.urlDEL = $(this.btnSelectorDEL).data('url');
        this.urlCTT = $(this.btnSelectorCTT).data('url');
        this.urlGLS = $(this.btnSelectorGLS).data('url');
        this.urlMRE = $(this.btnSelectorMRE).data('url');
        this.urlGLSHU = $(this.btnSelectorGLSHU).data('url');
        this.urlDPD = $(this.btnSelectorDPD).data('url');
        this.urlFAN = $(this.btnSelectorFAN).data('url');
        this.urlXBS = $(this.btnSelectorXBS).data('url');
        if ($('#pickupPointButton').length > 0) {
            this.checkboxDHL = $($($('#pickupPointButton')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
        };
        if ($('#pickupPointButtonIN').length > 0) {
            this.checkboxInpost = $($($('#pickupPointButtonIN')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
            this.woosmapListenerInPost();
        };
        if ($('#pickupPointButtonBRT').length > 0) {
            this.checkboxBRTExpress = $('.js-shipping-method[data-pickup-point-type=BRTPUP]');
            this.checkboxBRT = $($($('#pickupPointButtonBRT')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
            this.woosmapListenerBRT();
        };
        if ($('#pickupPointButtonPPL').length > 0) {
            this.checkboxPPLExpress = $('.js-shipping-method[data-pickup-point-type=PPLPUP]');
            this.checkboxPPL = $($($('#pickupPointButtonPPL')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
            this.woosmapListenerPPL();
        };
        if ($('#pickupPointButtonCLSS').length > 0) {
            this.checkboxPPLExpress = $('.js-shipping-method[data-pickup-point-type=CLSS]');
            this.checkboxPPL = $($($('#pickupPointButtonCLSS')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
            this.woosmapListenerCLSS();
        };
        if ($('#pickupPointButtonDHL').length > 0) {
            this.checkboxDHLLocationFinderExpress = $('.js-shipping-method[data-pickup-point-type=DHLLocationPUP]');
            this.checkboxDHLLocationFinder = $($($('#pickupPointButtonDHL')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
            this.woosmapListenerDHL();
        };
        if ($('#pickupPointButtonHermes').length > 0) {
            this.checkboxHermesExpress = $('.js-shipping-method[data-pickup-point-type=hermes]');
            this.checkboxHermes = $($($('#pickupPointButtonHermes')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
            this.woosmapListenerHermes();
        };
        if ($('#pickupPointButtonBPOST').length > 0) {
            this.checkboxBPOSTExpress = $('.js-shipping-method[data-pickup-point-type=BPOST]');
            this.checkboxBPOST = $($($('#pickupPointButtonBPOST')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
            this.woosmapListenerPudoBFF();
        };
        if ($('#pickupPointButtonPDB').length > 0) {
            this.checkboxPDBExpress = $('.js-shipping-method[data-pickup-point-type=PDB]');
            this.checkboxPDB = $($($('#pickupPointButtonPDB')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
            this.woosmapListenerPudoBFF();
        };
        if ($('#pickupPointButtonEVR').length > 0) {
            this.checkboxEVRExpress = $('.js-shipping-method[data-pickup-point-type=EVR]');
            this.checkboxEVR = $($($('#pickupPointButtonEVR')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
            this.woosmapListenerPudoBFF();
        };
        if ($('#pickupPointButtonPTN').length > 0) {
            this.checkboxPTNExpress = $('.js-shipping-method[data-pickup-point-type=PTN]');
            this.checkboxPTN = $($($('#pickupPointButtonPTN')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
            this.woosmapListenerPudoBFF();
        };
        if ($('#pickupPointButtonEST').length > 0) {
            this.checkboxESTExpress = $('.js-shipping-method[data-pickup-point-type=EST]');
            this.checkboxEST = $($($('#pickupPointButtonEST')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
            this.woosmapListenerPudoBFF();
        };
        if ($('#pickupPointButtonDEL').length > 0) {
            this.checkboxDELExpress = $('.js-shipping-method[data-pickup-point-type=DEL]');
            this.checkboxDEL = $($($('#pickupPointButtonDEL')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
            this.woosmapListenerPudoBFF();
        };
        if ($('#pickupPointButtonCTT').length > 0) {
            this.checkboxCTTExpress = $('.js-shipping-method[data-pickup-point-type=CTT]');
            this.checkboxCTT = $($($('#pickupPointButtonCTT')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
            this.woosmapListenerPudoBFF();
        };
        if ($('#pickupPointButtonGLS').length > 0) {
            this.checkboxGLSExpress = $('.js-shipping-method[data-pickup-point-type=GLS]');
            this.checkboxGLS = $($($('#pickupPointButtonGLS')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
            this.woosmapListenerPudoBFF();
        };
        if ($('#pickupPointButtonMRE').length > 0) {
            this.checkboxMREExpress = $('.js-shipping-method[data-pickup-point-type=MRE]');
            this.checkboxMRE = $($($('#pickupPointButtonMRE')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
            this.woosmapListenerPudoBFF();
        };
        if ($('#pickupPointButtonGLSHU').length > 0) {
            this.checkboxGLSHUExpress = $('.js-shipping-method[data-pickup-point-type=GLSHU]');
            this.checkboxGLSHU = $($($('#pickupPointButtonGLSHU')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
            this.woosmapListenerPudoBFF();
        };
        if ($('#pickupPointButtonDPD').length > 0) {
            this.checkboxDPDExpress = $('.js-shipping-method[data-pickup-point-type=DPDPUP]');
            this.checkboxDPD = $($($('#pickupPointButtonDPD')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
            this.woosmapListenerPudoBFF();
        };
        if ($('#pickupPointButtonFAN').length > 0) {
            this.checkboxFANExpress = $('.js-shipping-method[data-pickup-point-type=FAN]');
            this.checkboxFAN = $($($('#pickupPointButtonFAN')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
            this.woosmapListenerPudoBFF();
        };
        if ($('#pickupPointButtonXBS').length > 0) {
            this.checkboxXBSExpress = $('.js-shipping-method[data-pickup-point-type=XBS]');
            this.checkboxXBS = $($($('#pickupPointButtonXBS')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');
            this.woosmapListenerPudoBFF();
        };

        if ($('#pickupPointButtonOSM').length > 0 && $('#modalOSM').find('.ruch_widget').length === 0) {
            var _self = this;
            var isProduction = ($('#isProductionEnvironment').val() && $('#isProductionEnvironment').val() == 'true') ? 0 : 1;
            var wid = new RuchWidget('modalOSM', {
                // loadCb: on_load, // Called when the map is loaded
                readyCb: onReadyOSM(),
                selectCb: onSelectOSM,
                initialAddress: $('#start').val(), // Start map center – point ID or address
                sandbox: isProduction, // 1 if widget is supposed to fetch test data instead of production data
                showCodFilter: 0, // Display COD (cash on delivery) filter
                showPointTypeFilter: 0, // Display point type filter
                showDeliveryFilter: 0 // Display delivery type filter
            });
            wid.init();

            this.checkboxOSMExpress = $('.js-shipping-method[data-pickup-point-type=OPPLPUPC]');
            this.checkboxOSM = $($($('#pickupPointButtonOSM')[0].parentElement.closest('.shipping-method'))[0]).find('.radio-input');

            // eslint-disable-next-line no-inner-declarations
            function onReadyOSM () {
                $('.js-select-pickup-OSM').removeClass('disabled');

                $('body').on('click', '#pickupPointButtonOSM', function () {
                    _self.modal = new ModalShowHide(_self.elementSelectorOSM);
                    _self.modal.show();

                    $(_self.modal.modalBox).on('click', '.close, .btn-close', (e) => {
                        e.preventDefault();
                        _self.modal.hide();
                    });

                    var shippingCost = $('#js-shipping-cost-osm').val();
                    $('.js-modal-osm').removeClass('hide');
                    wid.showWidget(0, {'R': shippingCost, 'P': shippingCost, 'U': shippingCost, 'A': shippingCost}, {'R': 'ruch' + 0, 'P': 'partner' + 0, 'U': 'partner' + 0, 'A': 'orlen' + 0});
                    wid.setPointType('PSP, PPP, PSF, PSD, APM,PKN');
                });
            }

            // eslint-disable-next-line no-inner-declarations
            function onSelectOSM (p) {
                if (p) {
                    var selectedStoreId = p.id;
                    var storeName = p.h;
                    var storeAddress = p.a_al;
                    var storeCity = p.a_c;
                    var postalCode = p.a_pc;
                    $('.js-pickup-name-OSM').html(storeName);
                    $('.js-pickup-address1-OSM').html(storeAddress);
                    $('.js-pickup-address2-OSM').html(storeCity);
                    $('.js-pickup-postalcode-OSM').html(postalCode);

                    $('.js-select-pickup-OSM').addClass('hide');
                    $('.js-change-pickup-OSM').show();

                    $('.selectedPickupRecapOSM').removeClass('hide');

                    if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                        $('.selectedPickupRecap').addClass('hide');
                        $('.js-select-pickup').removeClass('hide');
                    }

                    const data = {
                        number: selectedStoreId,
                        name: storeName,
                        address1: storeAddress,
                        city: storeCity,
                        postalCode: postalCode
                    };

                    $('body').trigger('OSM:selectedPickup', data);

                    _self.modal.hide();
                }
            }
        };

        woosmapListenerForModalClose();
    }

    hasCoordinates () {
        return this.coordinates.lat && this.coordinates.long;
    }

    addSearchListener () {
        var _self = this;
        // Handle typing in search field
        $('body').on('keyup', '#pickupPointMapModal input[name="querycity"]', (e) => {
            const $searchButton = $('#pickupPointMapModal').parent().find('[type="submit"]');

            if ($('#pickupPointMapModal input[name="querycity"]').val().length > 3 && $('#pickupPointMapModal input[name="querypostal"]').val().length > 4) {
                $searchButton.removeAttr('disabled');
            } else {
                $searchButton.attr('disabled', 'disabled');
            }
        });

        // Handle Radius button change
        $('body').on('change', this.radiusSelector, (e) => {
            this.getStores();
            e.preventDefault();
        });

        // Handle "show on map" click
        $('body').on('click', '.fi-show-on-map, .fi-show-on-map-PDB, .fi-show-on-map-GLS, .fi-show-on-map-DEL, .fi-show-on-map-CTT', (e) => {
            const coords = {
                lat: Number($(e.currentTarget).data('coords').split(',')[0]),
                lng: Number($(e.currentTarget).data('coords').split(',')[1])
            };
            const clickedElement = e.currentTarget; 
            const mapType = [...clickedElement.classList]
                .find(cls => cls.startsWith('fi-show-on-map-'))
                ?.replace('fi-show-on-map-', '');
        
            this.map.centerMapOnCoordinates(coords);
            this.scrollToMap(mapType);
            e.preventDefault();
            e.stopPropagation();
        });

        $('body').on('click', '.fi-show-on-map-inpost', (e) => {
            const coords = {
                lat: Number($(e.currentTarget).data('coords').split(',')[0]),
                lng: Number($(e.currentTarget).data('coords').split(',')[1])
            };

            this.map.centerMapOnCoordinates(coords);
            this.scrollToMapInPost();
            e.preventDefault();
            e.stopPropagation();
        });

        $('body').on('click', '.fi-show-on-map-ppl', (e) => {
            const coords = {
                lat: Number($(e.currentTarget).data('coords').split(',')[0]),
                lng: Number($(e.currentTarget).data('coords').split(',')[1])
            };

            this.map.centerMapOnCoordinates(coords);
            this.scrollToMapPPL();
            e.preventDefault();
            e.stopPropagation();
        });

        $('body').on('click', '.fi-show-on-map-CLSS', (e) => {
            const coords = {
                lat: Number($(e.currentTarget).data('coords').split(',')[0]),
                lng: Number($(e.currentTarget).data('coords').split(',')[1])
            };

            this.map.centerMapOnCoordinates(coords);
            this.scrollToMapCLSS();
            e.preventDefault();
            e.stopPropagation();
        });

        $('body').on('click', '.fi-show-on-map-dhl', (e) => {
            const coords = {
                lat: Number($(e.currentTarget).data('coords').split(',')[0]),
                lng: Number($(e.currentTarget).data('coords').split(',')[1])
            };

            this.map.centerMapOnCoordinates(coords);
            this.scrollToMapDHL();
            e.preventDefault();
            e.stopPropagation();
        });

        $('body').on('click', '.fi-show-on-map-brt', (e) => {
            const coords = {
                lat: Number($(e.currentTarget).data('coords').split(',')[0]),
                lng: Number($(e.currentTarget).data('coords').split(',')[1])
            };

            this.map.centerMapOnCoordinates(coords);
            this.scrollToMapBRT();
            e.preventDefault();
            e.stopPropagation();
        });

        $('body').on('click', '.fi-show-on-map-dpd', (e) => {
            const coords = {
                lat: Number($(e.currentTarget).data('coords').split(',')[0]),
                lng: Number($(e.currentTarget).data('coords').split(',')[1])
            };

            this.map.centerMapOnCoordinates(coords);
            this.scrollToMapDPD();
            e.preventDefault();
            e.stopPropagation();
        });

        $('body').on('click', '.fi-show-on-map-hermes', (e) => {
            const coords = {
                lat: Number($(e.currentTarget).data('coords').split(',')[0]),
                lng: Number($(e.currentTarget).data('coords').split(',')[1])
            };

            this.map.centerMapOnCoordinates(coords);
            this.scrollToMapHermes();
            e.preventDefault();
            e.stopPropagation();
        });

        $('body').off('click', '#InPost-usecurrentposition');

        $('body').on('click', '#InPost-usecurrentposition', (e) => {
            this.detectLocationPickupPoint();

            e.preventDefault();
            e.stopPropagation();
        });

        $('body').off('click', '#PPL-usecurrentposition');

        $('body').on('click', '#PPL-usecurrentposition', (e) => {
            this.detectLocationPickupPoint();

            e.preventDefault();
            e.stopPropagation();
        });

        $('body').off('click', '#CLSS-usecurrentposition');

        $('body').on('click', '#CLSS-usecurrentposition', (e) => {
            this.detectLocationPickupPoint();

            e.preventDefault();
            e.stopPropagation();
        });

        $('body').off('click', '#DHL-usecurrentposition');

        $('body').on('click', '#DHL-usecurrentposition', (e) => {
            this.detectLocationPickupPoint();

            e.preventDefault();
            e.stopPropagation();
        });

        $('body').off('click', '#BRT-usecurrentposition');

        $('body').on('click', '#BRT-usecurrentposition', (e) => {
            this.detectLocationPickupPoint();

            e.preventDefault();
            e.stopPropagation();
        });

        $('body').off('click', '#DPD-usecurrentposition');

        $('body').on('click', '#DPD-usecurrentposition', (e) => {
            this.detectLocationPickupPoint();

            e.preventDefault();
            e.stopPropagation();
        });

        $('body').off('click', '#hermes-usecurrentposition');

        $('body').on('click', '#hermes-usecurrentposition', (e) => {
            this.detectLocationPickupPoint();

            e.preventDefault();
            e.stopPropagation();
        });

        $('body').off('click', '#js-useCurrentPositionEVR, #js-useCurrentPositionPTN, #js-useCurrentPositionEST, #js-usecurrentposition-MRE, #js-usecurrentposition-GLSHU');

        $('body').on('click', '#js-useCurrentPositionEVR, #js-useCurrentPositionPTN, #js-useCurrentPositionEST, #js-usecurrentposition-MRE, #js-usecurrentposition-GLSHU', (e) => {
            this.detectLocationPickupPoint();

            e.preventDefault();
            e.stopPropagation();
        });

        $('body').on('click', '.js-choose-pickup', (e) => {
            this.checkboxDHL.click();

            const selectedStoreId = e.target.dataset.storeSap;

            const storeName = $(e.target).closest('.result').find('.js-pickup-name').html();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').html();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').html();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').html();

            $('.js-pickup-name').html(storeName);
            $('.js-pickup-address1').html(storeAddress);
            $('.js-pickup-address2').html(storeCity);
            $('.js-pickup-postalcode').html(postalCode);

            $('.js-select-pickup').addClass('hide');
            $('.js-change-pickup').show();

            $('.selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecapInPost').hasClass('hide')) || $('.js-select-pickup-InPost').hasClass('hide')) {
                $('.selectedPickupRecapInPost').addClass('hide');
                $('.js-select-pickup-InPost').removeClass('hide');
            }

            const data = {
                number: selectedStoreId,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode
            };

            $('body').trigger('DhlPickup:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickupPointIN', (e) => {
            this.checkboxInpost.click();

            const storeName = $(e.target).closest('.result').find('.js-pickup-name').html();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').html();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').html();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').html();

            $('.js-pickup-name-InPost').html(storeName);
            $('.js-pickup-address1-InPost').html(storeAddress);
            $('.js-pickup-address2-InPost').html(storeCity);
            $('.js-pickup-postalcode-InPost').html(postalCode);

            $('.js-select-pickup-InPost').addClass('hide');
            $('.js-change-pickup-InPost').show();

            $('.selectedPickupRecapInPost').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }
            if ((!$('.selectedPickupRecapDPD').hasClass('hide')) || $('.js-select-pickup-DPD').hasClass('hide')) {
                $('.selectedPickupRecapDPD').addClass('hide');
                $('.js-select-pickup-DPD').removeClass('hide');
            }
            const data = {
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode
            };

            $('body').trigger('InPost:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickupPointPPL', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxPPLExpress.click();
            } else {
                this.checkboxPPL.click();
            }

            const selectedStoreId = e.target.dataset.storeSap;

            const storeName = $(e.target).closest('.result').find('.js-pickup-name').html();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').html();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').html();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').html();

            $('.js-pickup-name-PPL').html(storeName);
            $('.js-pickup-address1-PPL').html(storeAddress);
            $('.js-pickup-address2-PPL').html(storeCity);
            $('.js-pickup-postalcode-PPL').html(postalCode);
            $('.js-pickup-sap-PPL').html(selectedStoreId);

            $('.js-select-pickup-PPL').addClass('hide');
            $('.js-change-pickup-PPL').show();

            $('.selectedPickupRecapPPL').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }
            const data = {
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                sap: selectedStoreId
            };

            $('body').trigger('PPL:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickupPointCLSS', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxPPLExpress.click();
            } else {
                this.checkboxPPL.click();
            }

            const selectedStoreId = e.target.dataset.storeSap;

            const storeName = $(e.target).closest('.result').find('.js-pickup-name').html();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').html();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').html();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').html();
            const type = $(e.target).closest('.result').find('.js-pickup-type').html();

            $('.js-pickup-name-CLSS').html(storeName);
            $('.js-pickup-address1-CLSS').html(storeAddress);
            $('.js-pickup-address2-CLSS').html(storeCity);
            $('.js-pickup-postalcode-CLSS').html(postalCode);
            $('.js-pickup-sap-CLSS').html(selectedStoreId);
            $('.js-pickup-type-CLSS').html(type);

            $('.js-select-pickup-CLSS').addClass('hide');
            $('.js-change-pickup-CLSS').show();

            $('.selectedPickupRecapCLSS').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }
            const data = {
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                sap: selectedStoreId,
                type: type
            };

            $('body').trigger('CLSS:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickupPointDHL', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxDHLLocationFinderExpress.click();
            } else {
                this.checkboxDHLLocationFinder.click();
            }
            const selectedStoreId = e.target.dataset.storeSap;

            const storeName = $(e.target).closest('.result').find('.js-pickup-name').html();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').html();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').html();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').html();
            const isPackstation = $(e.target).closest('.result').data('packstation');

            $('.js-pickup-name-DHL').html(storeName);
            $('.js-pickup-address1-DHL').html(storeAddress);
            $('.js-pickup-address2-DHL').html(storeCity);
            $('.js-pickup-postalcode-DHL').html(postalCode);
            $('.js-pickup-sap-DHL').html(selectedStoreId);
            if (isPackstation) {
                $('.js-pickup-packstation-DHL').removeClass('hide');
                $('.js-pickup-packstation-DHL').find('#dhl-locker').val('true');
            } else {
                $('.js-pickup-packstation-DHL').addClass('hide');
                $('.js-pickup-packstation-DHL').find('#dhl-postnumber').val('');
                $('.js-pickup-packstation-DHL').find('#dhl-locker').val('');
            }

            $('.js-select-pickup-DHL').addClass('hide');
            $('.js-change-pickup-DHL').show();

            $('.selectedPickupRecapDHL').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }
            const data = {
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                sap: selectedStoreId,
                isPackstation: isPackstation
            };

            $('body').trigger('DHL:selectedPickup', data);
            this.modal.hide();
        });



        $('body').on('click', '.js-choose-pickupPointBRT', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxBRTExpress.click();
            } else {
                this.checkboxBRT.click();
            }
            const selectedStoreId = e.target.dataset.storeSap;

            const storeName = $(e.target).closest('.result').find('.js-pickup-name').html();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').html();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').html();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').html();

            $('.js-pickup-name-BRT').html(storeName);
            $('.js-pickup-address1-BRT').html(storeAddress);
            $('.js-pickup-address2-BRT').html(storeCity);
            $('.js-pickup-postalcode-BRT').html(postalCode);
            $('.js-pickup-sap-BRT').html(selectedStoreId);

            $('.js-select-pickup-BRT').addClass('hide');
            $('.js-change-pickup-BRT').show();

            $('.selectedPickupRecapBRT').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }
            const data = {
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                number: selectedStoreId
            };

            $('body').trigger('BRT:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickupPointHermes', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxHermesExpress.click();
            } else {
                this.checkboxHermes.click();
            }
            const selectedStoreId = e.target.dataset.storeSap;

            const storeName = $(e.target).closest('.result').find('.js-pickup-name').html();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').html();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').html();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').html();

            $('.js-pickup-name-hermes').html(storeName);
            $('.js-pickup-address1-hermes').html(storeAddress);
            $('.js-pickup-address2-hermes').html(storeCity);
            $('.js-pickup-postalcode-hermes').html(postalCode);

            $('.js-select-pickup-hermes').addClass('hide');
            $('.js-change-pickup-hermes').show();

            $('.selectedPickupRecapHermes').removeClass('hide');

            const data = {
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                sap: selectedStoreId
            };

            $('body').trigger('Hermes:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickup-infowindow', (e) => {
            this.checkboxDHL.click();

            const selectedStoreSap = e.target.dataset.storeSap;

            const $result = $('#pickupPointList').find('.result').filter(`[data-store-sap="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').html();
            const storeAddress = $result.find('.js-pickup-address-row1').html();
            const storeCity = $result.find('.js-pickup-city').html();
            const postalCode = $result.find('.js-pickup-postalcode').html();

            $('.js-pickup-name').html(storeName);
            $('.js-pickup-address1').html(storeAddress);
            $('.js-pickup-address2').html(storeCity);
            $('.js-pickup-postalcode').html(postalCode);

            $('.js-select-pickup').addClass('hide');
            $('.js-change-pickup').show();

            $('.selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecapInPost').hasClass('hide')) || $('.js-select-pickup-InPost').hasClass('hide')) {
                $('.selectedPickupRecapInPost').addClass('hide');
                $('.js-select-pickup-InPost').removeClass('hide');
            }

            const data = {
                number: selectedStoreSap,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode
            };

            $('body').trigger('DhlPickup:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickup-infowindow-InPost', (e) => {
            this.checkboxInpost.click();

            const selectedStoreSap = e.target.dataset.storeId;

            const $result = $('#pickupPointListInPost').find('.result').filter(`[data-store-id="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').html();
            const storeAddress = $result.find('.js-pickup-address-row1').html();
            const storeCity = $result.find('.js-pickup-city').html();
            const postalCode = $result.find('.js-pickup-postalcode').html();

            $('.js-pickup-name-InPost').html(storeName);
            $('.js-pickup-address1-InPost').html(storeAddress);
            $('.js-pickup-address2-InPost').html(storeCity);
            $('.js-pickup-postalcode-InPost').html(postalCode);

            $('.js-select-pickup-InPost').addClass('hide');
            $('.js-change-pickup-InPost').show();

            $('.selectedPickupRecapInPost').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }
            if ((!$('.selectedPickupRecapDPD').hasClass('hide')) || $('.js-select-pickup-DPD').hasClass('hide')) {
                $('.selectedPickupRecapDPD').addClass('hide');
                $('.js-select-pickup-DPD').removeClass('hide');
            }

            const data = {
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode
            };

            $('body').trigger('InPost:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickup-infowindow-PPL', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxPPLExpress.click();
            } else {
                this.checkboxPPL.click();
            }

            const selectedStoreSap = e.target.dataset.storeSap;

            const $result = $('#pickupPointListPPL').find('.result').filter(`[data-store-sap="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').html();
            const storeAddress = $result.find('.js-pickup-address-row1').html();
            const storeCity = $result.find('.js-pickup-city').html();
            const postalCode = $result.find('.js-pickup-postalcode').html();

            $('.js-pickup-name-PPL').html(storeName);
            $('.js-pickup-address1-PPL').html(storeAddress);
            $('.js-pickup-address2-PPL').html(storeCity);
            $('.js-pickup-postalcode-PPL').html(postalCode);
            $('.js-pickup-sap-PPL').html(selectedStoreSap);

            $('.js-select-pickup-PPL').addClass('hide');
            $('.js-change-pickup-PPL').show();

            $('.selectedPickupRecapPPL').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                sap: selectedStoreSap
            };

            $('body').trigger('PPL:selectedPickup', data);
            this.modal.hide();
        });
        $('body').on('click', '.js-choose-pickup-infowindow-CLSS', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxPPLExpress.click();
            } else {
                this.checkboxPPL.click();
            }

            const selectedStoreSap = e.target.dataset.storeSap;

            const $result = $('#pickupPointListCLSS').find('.result').filter(`[data-store-sap="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').html();
            const storeAddress = $result.find('.js-pickup-address-row1').html();
            const storeCity = $result.find('.js-pickup-city').html();
            const postalCode = $result.find('.js-pickup-postalcode').html();
            const type = $result.find('.js-pickup-type').html();

            $('.js-pickup-name-CLSS').html(storeName);
            $('.js-pickup-address1-CLSS').html(storeAddress);
            $('.js-pickup-address2-CLSS').html(storeCity);
            $('.js-pickup-postalcode-CLSS').html(postalCode);
            $('.js-pickup-sap-CLSS').html(selectedStoreSap);
            $('.js-pickup-type-CLSS').html(type);

            $('.js-select-pickup-CLSS').addClass('hide');
            $('.js-change-pickup-CLSS').show();

            $('.selectedPickupRecapCLSS').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                sap: selectedStoreSap
            };

            $('body').trigger('CLSS:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickup-infowindow-DHL', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxDHLLocationFinderExpress.click();
            } else {
                this.checkboxDHLLocationFinder.click();
            }
            const selectedStoreSap = e.target.dataset.storeSap;

            const $result = $('#pickupPointListDHL').find('.result').filter(`[data-store-sap="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').html();
            const storeAddress = $result.find('.js-pickup-address-row1').html();
            const storeCity = $result.find('.js-pickup-city').html();
            const postalCode = $result.find('.js-pickup-postalcode').html();
            const isPackstation = $result.data('packstation');

            $('.js-pickup-name-DHL').html(storeName);
            $('.js-pickup-address1-DHL').html(storeAddress);
            $('.js-pickup-address2-DHL').html(storeCity);
            $('.js-pickup-postalcode-DHL').html(postalCode);
            $('.js-pickup-sap-DHL').html(selectedStoreSap);
            if (isPackstation) {
                $('.js-pickup-packstation-DHL').removeClass('hide');
                $('.js-pickup-packstation-DHL').find('#dhl-locker').val('true');
            } else {
                $('.js-pickup-packstation-DHL').addClass('hide');
                $('.js-pickup-packstation-DHL').find('#dhl-postnumber').val('');
                $('.js-pickup-packstation-DHL').find('#dhl-locker').val('');
            }

            $('.js-select-pickup-DHL').addClass('hide');
            $('.js-change-pickup-DHL').show();

            $('.selectedPickupRecapDHL').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                sap: selectedStoreSap,
                isPackstation: isPackstation
            };

            $('body').trigger('DHL:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickup-infowindow-BRT', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxBRTExpress.click();
            } else {
                this.checkboxBRT.click();
            }
            const selectedStoreSap = e.target.dataset.storeSap;

            const $result = $('#pickupPointListBRT').find('.result').filter(`[data-store-sap="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').html();
            const storeAddress = $result.find('.js-pickup-address-row1').html();
            const storeCity = $result.find('.js-pickup-city').html();
            const postalCode = $result.find('.js-pickup-postalcode').html();

            $('.js-pickup-name-BRT').html(storeName);
            $('.js-pickup-address1-BRT').html(storeAddress);
            $('.js-pickup-address2-BRT').html(storeCity);
            $('.js-pickup-postalcode-BRT').html(postalCode);
            $('.js-pickup-sap-BRT').html(selectedStoreSap);

            $('.js-select-pickup-BRT').addClass('hide');
            $('.js-change-pickup-BRT').show();

            $('.selectedPickupRecapBRT').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                number: selectedStoreSap
            };

            $('body').trigger('BRT:selectedPickup', data);
            this.modal.hide();
            $('body').trigger(document.exitFullscreen());
        });

        $('body').on('click', '.js-choose-pickup-infowindow-hermes', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxHermesExpress.click();
            } else {
                this.checkboxHermes.click();
            }
            const selectedStoreSap = e.target.dataset.storeSap;

            const $result = $('#pickupPointListHermes').find('.result').filter(`[data-store-sap="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').html();
            const storeAddress = $result.find('.js-pickup-address-row1').html();
            const storeCity = $result.find('.js-pickup-city').html();
            const postalCode = $result.find('.js-pickup-postalcode').html();

            $('.js-pickup-name-hermes').html(storeName);
            $('.js-pickup-address1-hermes').html(storeAddress);
            $('.js-pickup-address2-hermes').html(storeCity);
            $('.js-pickup-postalcode-hermes').html(postalCode);

            $('.js-select-pickup-hermes').addClass('hide');
            $('.js-change-pickup-hermes').show();

            $('.selectedPickupRecapHermes').removeClass('hide');

            const data = {
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                sap: selectedStoreSap
            };

            $('body').trigger('Hermes:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickupPointBPOST', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxBPOSTExpress.click();
            } else {
                this.checkboxBPOST.click();
            }

            const selectedStoreId = e.target.dataset.storeSap;

            const storeName = $(e.target).closest('.result').find('.js-pickup-name').html();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').html();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').html();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').html();
            const type = $(e.target).closest('.result').find('.js-pickup-type').html();

            $('.js-pickup-name-BPOST').html(storeName);
            $('.js-pickup-address1-BPOST').html(storeAddress);
            $('.js-pickup-address2-BPOST').html(storeCity);
            $('.js-pickup-postalcode-BPOST').html(postalCode);
            $('.js-pickup-sap-BPOST').html(selectedStoreId);
            $('.js-pickup-type-BPOST').html(type);

            $('.js-select-pickup-BPOST').addClass('hide');
            $('.js-change-pickup-BPOST').removeClass('hide');

            $('.selectedPickupRecapBPOST').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreId,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                type: type,
                shippingMethodType: _self.selectedShippingMethodType
            };

            $('body').trigger('STANDARD:selectedPickup', data);
        });

        $('body').on('click', '.js-choose-pickup-infowindow-BPOST', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxBPOSTExpress.click();
            } else {
                this.checkboxBPOST.click();
            }

            const selectedStoreSap = e.target.dataset.storeSap;

            const $result = $('#pickupPointListBPOST').find('.result').filter(`[data-store-sap="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').html();
            const storeAddress = $result.find('.js-pickup-address-row1').html();
            const storeCity = $result.find('.js-pickup-city').html();
            const postalCode = $result.find('.js-pickup-postalcode').html();
            const type = $result.find('.js-pickup-type').html();

            $('.js-pickup-name-BPOST').html(storeName);
            $('.js-pickup-address1-BPOST').html(storeAddress);
            $('.js-pickup-address2-BPOST').html(storeCity);
            $('.js-pickup-postalcode-BPOST').html(postalCode);
            $('.js-pickup-sap-BPOST').html(selectedStoreSap);
            $('.js-pickup-type-BPOST').html(type);

            $('.js-select-pickup-BPOST').addClass('hide');
            $('.js-change-pickup-BPOST').removeClass('hide');

            $('.selectedPickupRecapBPOST').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreSap,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                type: type,
                shippingMethodType: _self.selectedShippingMethodType
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickupPointPDB', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                if (this.checkboxPDBExpress) {
                    this.checkboxPDBExpress.click();
                }
            } else {
                this.checkboxPDB.click();
            }

            const selectedStoreId = e.target.dataset.storeSap;

            const storeName = $(e.target).closest('.result').find('.js-pickup-name').html();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').html();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').html();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').html();
            const type = $(e.target).closest('.result').find('.js-pickup-type').html();
            const serviceType = $(e.target).closest('.result').find('.js-pickup-servicetype').html();

            $('.js-pickup-name-PDB').html(storeName);
            $('.js-pickup-address1-PDB').html(storeAddress);
            $('.js-pickup-address2-PDB').html(storeCity);
            $('.js-pickup-postalcode-PDB').html(postalCode);
            $('.js-pickup-sap-PDB').html(selectedStoreId);
            $('.js-pickup-type-PDB').html(type);
            $('.js-pickup-servicetype-PDB').html(serviceType);

            $('.js-select-pickup-PDB').addClass('hide');
            $('.js-change-pickup-PDB').removeClass('hide');

            $('.selectedPickupRecapPDB').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreId,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                type: type,
                serviceType: serviceType // PDB needs serviceType as pickupPointName to close the order
            };

            $('body').trigger('PDB:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickup-infowindow-PDB', (e) => {
            this.checkboxPDB.click();

            const selectedStoreSap = e.target.dataset.storeSap;

            const $result = $('#pickupPointListPDB').find('.result').filter(`[data-store-sap="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').html();
            const storeAddress = $result.find('.js-pickup-address-row1').html();
            const storeCity = $result.find('.js-pickup-city').html();
            const postalCode = $result.find('.js-pickup-postalcode').html();
            const type = $result.find('.js-pickup-type').html();
            const serviceType = $result.find('.js-pickup-servicetype').html();

            $('.js-pickup-name-PDB').html(storeName);
            $('.js-pickup-address1-PDB').html(storeAddress);
            $('.js-pickup-address2-PDB').html(storeCity);
            $('.js-pickup-postalcode-PDB').html(postalCode);
            $('.js-pickup-sap-PDB').html(selectedStoreSap);
            $('.js-pickup-type-PDB').html(type);
            $('.js-pickup-servicetype-PDB').html(serviceType);

            $('.js-select-pickup-PDB').addClass('hide');
            $('.js-change-pickup-PDB').removeClass('hide');

            $('.selectedPickupRecapPDB').removeClass('hide');
            // $('.selectedPickupRecapPDB').removeClass('null');


            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreSap,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                type: type,
                serviceType: serviceType // PDB needs serviceType as pickupPointName to close the order
            };

            $('body').trigger('PDB:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickupPointEST', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxESTExpress.trigger('click');
            } else {
                this.checkboxEST.trigger('click');
            }

            const selectedStoreId = e.target.dataset.storeSap;

            const storeName = $(e.target).closest('.result').find('.js-pickup-name').text();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').text();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').text();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').text();

            $('.js-pickup-name-EST').text(storeName);
            $('.js-pickup-address1-EST').text(storeAddress);
            $('.js-pickup-address2-EST').text(storeCity);
            $('.js-pickup-postalcode-EST').text(postalCode);
            $('.js-pickup-sap-EST').text(selectedStoreId);

            $('.js-select-pickup-EST').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreId,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                shippingMethodType: _self.selectedShippingMethodType
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickup-infowindow-EST', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxESTExpress.trigger('click');
            } else {
                this.checkboxEST.trigger('click');
            }

            const selectedStoreSap = e.target.dataset.storeSap;

            const $result = $('#pickupPointListEST').find('.result').filter(`[data-store-sap="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').text();
            const storeAddress = $result.find('.js-pickup-address-row1').text();
            const storeCity = $result.find('.js-pickup-city').text();
            const postalCode = $result.find('.js-pickup-postalcode').text();

            $('.js-pickup-name-EST').text(storeName);
            $('.js-pickup-address1-EST').text(storeAddress);
            $('.js-pickup-address2-EST').text(storeCity);
            $('.js-pickup-postalcode-EST').text(postalCode);
            $('.js-pickup-sap-EST').text(selectedStoreSap);

            $('.js-select-pickup-EST').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreSap,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                shippingMethodType: _self.selectedShippingMethodType
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickupPointDEL', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxDELExpress.trigger('click');
            } else {
                this.checkboxDEL.trigger('click');
            }

            const selectedStoreId = e.target.dataset.storeSap;

            const storeName = $(e.target).closest('.result').find('.js-pickup-name').text();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').text();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').text();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').text();

            $('.js-pickup-name-DEL').text(storeName);
            $('.js-pickup-address1-DEL').text(storeAddress);
            $('.js-pickup-address2-DEL').text(storeCity);
            $('.js-pickup-postalcode-DEL').text(postalCode);
            $('.js-pickup-sap-DEL').text(selectedStoreId);

            $('.js-select-pickup-DEL').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreId,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickup-infowindow-DEL', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxDELExpress.trigger('click');
            } else {
                this.checkboxDEL.trigger('click');
            }

            const selectedStoreSap = e.target.dataset.storeSap;

            const $result = $('#pickupPointListDEL').find('.result').filter(`[data-store-sap="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').text();
            const storeAddress = $result.find('.js-pickup-address-row1').text();
            const storeCity = $result.find('.js-pickup-city').text();
            const postalCode = $result.find('.js-pickup-postalcode').text();

            $('.js-pickup-name-DEL').html(storeName);
            $('.js-pickup-address1-DEL').html(storeAddress);
            $('.js-pickup-address2-DEL').html(storeCity);
            $('.js-pickup-postalcode-DEL').html(postalCode);
            $('.js-pickup-sap-DEL').html(selectedStoreSap);
            $('.js-pickup-type-DEL').html(type);

            $('.js-select-pickup-DEL').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreSap,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickupPointCTT', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxCTTExpress.trigger('click');
            } else {
                this.checkboxCTT.trigger('click');
            }

            const selectedStoreId = e.target.dataset.storeSap;

            const storeName = $(e.target).closest('.result').find('.js-pickup-name').text();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').text();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').text();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').text();

            $('.js-pickup-name-CTT').text(storeName);
            $('.js-pickup-address1-CTT').text(storeAddress);
            $('.js-pickup-address2-CTT').text(storeCity);
            $('.js-pickup-postalcode-CTT').text(postalCode);
            $('.js-pickup-sap-CTT').text(selectedStoreId);

            $('.js-select-pickup-CTT').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreId,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickup-infowindow-CTT', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxCTTExpress.trigger('click');
            } else {
                this.checkboxCTT.trigger('click');
            }

            const selectedStoreSap = e.target.dataset.storeSap;

            const $result = $('#pickupPointListCTT').find('.result').filter(`[data-store-sap="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').text();
            const storeAddress = $result.find('.js-pickup-address-row1').text();
            const storeCity = $result.find('.js-pickup-city').text();
            const postalCode = $result.find('.js-pickup-postalcode').text();
            $('.js-pickup-name-CTT').text(storeName);
            $('.js-pickup-address1-CTT').text(storeAddress);
            $('.js-pickup-address2-CTT').text(storeCity);
            $('.js-pickup-postalcode-CTT').text(postalCode);
            $('.js-pickup-sap-CTT').text(selectedStoreSap);

            $('.js-select-pickup-CTT').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreSap,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickupPointGLS', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxGLSExpress.trigger('click');
            } else {
                this.checkboxGLS.trigger('click');
            }

            const selectedStoreId = e.target.dataset.storeSap;

            const storeName = $(e.target).closest('.result').find('.js-pickup-name').text();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').text();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').text();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').text();

            $('.js-pickup-name-GLS').text(storeName);
            $('.js-pickup-address1-GLS').text(storeAddress);
            $('.js-pickup-address2-GLS').text(storeCity);
            $('.js-pickup-postalcode-GLS').text(postalCode);
            $('.js-pickup-sap-GLS').text(selectedStoreId);

            $('.js-select-pickup-GLS').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreId,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickup-infowindow-GLS', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxGLSExpress.trigger('click');
            } else {
                this.checkboxGLS.trigger('click');
            }

            const selectedStoreSap = e.target.dataset.storeSap;

            const $result = $('#pickupPointListGLS').find('.result').filter(`[data-store-sap="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').text();
            const storeAddress = $result.find('.js-pickup-address-row1').text();
            const storeCity = $result.find('.js-pickup-city').text();
            const postalCode = $result.find('.js-pickup-postalcode').text();

            $('.js-pickup-name-GLS').text(storeName);
            $('.js-pickup-address1-GLS').text(storeAddress);
            $('.js-pickup-address2-GLS').text(storeCity);
            $('.js-pickup-postalcode-GLS').text(postalCode);
            $('.js-pickup-sap-GLS').text(selectedStoreSap);

            $('.js-select-pickup-GLS').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreSap,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickupPointMRE', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxMREExpress.trigger('click');
            } else {
                this.checkboxMRE.trigger('click');
            }

            const selectedStoreId = e.target.dataset.storeSap;

            const storeName = $(e.target).closest('.result').find('.js-pickup-name').text();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').text();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').text();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').text();

            $('.js-pickup-name-MRE').text(storeName);
            $('.js-pickup-address1-MRE').text(storeAddress);
            $('.js-pickup-address2-MRE').text(storeCity);
            $('.js-pickup-postalcode-MRE').text(postalCode);
            $('.js-pickup-sap-MRE').text(selectedStoreId);

            $('.js-select-pickup-MRE').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreId,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickup-infowindow-MRE', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxMREExpress.trigger('click');
            } else {
                this.checkboxMRE.trigger('click');
            }

            const selectedStoreSap = e.target.dataset.storeSap;

            const $result = $('#pickupPointListMRE').find('.result').filter(`[data-store-sap="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').text();
            const storeAddress = $result.find('.js-pickup-address-row1').text();
            const storeCity = $result.find('.js-pickup-city').text();
            const postalCode = $result.find('.js-pickup-postalcode').text();

            $('.js-pickup-name-MRE').text(storeName);
            $('.js-pickup-address1-MRE').text(storeAddress);
            $('.js-pickup-address2-MRE').text(storeCity);
            $('.js-pickup-postalcode-MRE').text(postalCode);
            $('.js-pickup-sap-MRE').text(selectedStoreSap);

            $('.js-select-pickup-MRE').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreSap,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickupPointGLSHU', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxGLSHUExpress.trigger('click');
            } else {
                this.checkboxGLSHU.trigger('click');
            }

            const selectedStoreId = e.target.dataset.storeSap;

            const storeName = $(e.target).closest('.result').find('.js-pickup-name').text();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').text();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').text();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').text();

            $('.js-pickup-name-GLSHU').text(storeName);
            $('.js-pickup-address1-GLSHU').text(storeAddress);
            $('.js-pickup-address2-GLSHU').text(storeCity);
            $('.js-pickup-postalcode-GLSHU').text(postalCode);
            $('.js-pickup-sap-GLSHU').text(selectedStoreId);

            $('.js-select-pickup-GLSHU').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreId,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickup-infowindow-GLSHU', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxGLSHUExpress.trigger('click');
            } else {
                this.checkboxGLSHU.trigger('click');
            }

            const selectedStoreSap = e.target.dataset.storeSap;

            const $result = $('#pickupPointListGLSHU').find('.result').filter(`[data-store-sap="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').text();
            const storeAddress = $result.find('.js-pickup-address-row1').text();
            const storeCity = $result.find('.js-pickup-city').text();
            const postalCode = $result.find('.js-pickup-postalcode').text();

            $('.js-pickup-name-GLSHU').text(storeName);
            $('.js-pickup-address1-GLSHU').text(storeAddress);
            $('.js-pickup-address2-GLSHU').text(storeCity);
            $('.js-pickup-postalcode-GLSHU').text(postalCode);
            $('.js-pickup-sap-GLSHU').text(selectedStoreSap);

            $('.js-select-pickup-GLSHU').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreSap,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickupPointDPD', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxDPDExpress.trigger('click');
            } else {
                this.checkboxDPD.trigger('click');
            }

            const selectedStoreId = e.target.dataset.storeSap;

            const storeName = $(e.target).closest('.result').find('.js-pickup-name').text();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').text();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').text();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').text();

            $('.js-pickup-name-DPD').text(storeName);
            $('.js-pickup-address1-DPD').text(storeAddress);
            $('.js-pickup-address2-DPD').text(storeCity);
            $('.js-pickup-postalcode-DPD').text(postalCode);
            $('.js-pickup-sap-DPD').text(selectedStoreId);

            $('.js-select-pickup-DPD').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreId,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickup-infowindow-DPD', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxDPDExpress.trigger('click');
            } else {
                this.checkboxDPD.trigger('click');
            }

            const selectedStoreSap = e.target.dataset.storeSap;

            const $result = $('#pickupPointListDPD').find('.result').filter(`[data-store-sap="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').text();
            const storeAddress = $result.find('.js-pickup-address-row1').text();
            const storeCity = $result.find('.js-pickup-city').text();
            const postalCode = $result.find('.js-pickup-postalcode').text();
            const type = $result.find('.js-pickup-type').text();
            $('.js-pickup-name-DPD').text(storeName);
            $('.js-pickup-address1-DPD').text(storeAddress);
            $('.js-pickup-address2-DPD').text(storeCity);
            $('.js-pickup-postalcode-DPD').text(postalCode);
            $('.js-pickup-sap-DPD').text(selectedStoreSap);
            $('.js-pickup-type-DPD').text(type);

            $('.js-select-pickup-DPD').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreSap,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });
        $('body').on('click', '.js-choose-pickupPointFAN', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                if (this.checkboxFANExpress) {
                    this.checkboxFANExpress.click();
                }
            } else {
                this.checkboxFAN.click();
            }
            const selectedStoreId = e.target.dataset.storeSap;
            const storeName = $(e.target).closest('.result').find('.js-pickup-name').html();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').html();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').html();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').html();
            const type = $(e.target).closest('.result').find('.js-pickup-type').html();
            const serviceType = $(e.target).closest('.result').find('.js-pickup-servicetype').html();
            $('.js-pickup-name-FAN').html(storeName);
            $('.js-pickup-address1-FAN').html(storeAddress);
            $('.js-pickup-address2-FAN').html(storeCity);
            $('.js-pickup-postalcode-FAN').html(postalCode);
            $('.js-pickup-sap-FAN').html(selectedStoreId);
            $('.js-pickup-type-FAN').html(type);
            $('.js-pickup-servicetype-FAN').html(serviceType);
            $('.js-select-pickup-FAN').addClass('hide');
            $('.js-change-pickup-FAN').removeClass('hide');
            $('.selectedPickupRecapFAN').removeClass('hide');
            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }
            const data = {
                number: selectedStoreId,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                type: type,
                serviceType: serviceType // FAN needs serviceType as pickupPointName to close the order
            };
            $('body').trigger('FAN:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickup-infowindow-FAN', (e) => {
            this.checkboxFAN.click();

            const selectedStoreSap = e.target.dataset.storeSap;

            const $result = $('#pickupPointListFAN').find('.result').filter(`[data-store-sap="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').html();
            const storeAddress = $result.find('.js-pickup-address-row1').html();
            const storeCity = $result.find('.js-pickup-city').html();
            const postalCode = $result.find('.js-pickup-postalcode').html();
            const type = $result.find('.js-pickup-type').html();
            const serviceType = $result.find('.js-pickup-servicetype').html();

            $('.js-pickup-name-FAN').html(storeName);
            $('.js-pickup-address1-FAN').html(storeAddress);
            $('.js-pickup-address2-FAN').html(storeCity);
            $('.js-pickup-postalcode-FAN').html(postalCode);
            $('.js-pickup-sap-FAN').html(selectedStoreSap);
            $('.js-pickup-type-FAN').html(type);
            $('.js-pickup-servicetype-FAN').html(serviceType);

            $('.js-select-pickup-FAN').addClass('hide');
            $('.js-change-pickup-FAN').removeClass('hide');

            $('.selectedPickupRecapFAN').removeClass('hide');
            // $('.selectedPickupRecapFAN').removeClass('null');


            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreSap,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                type: type,
                serviceType: serviceType // FAN needs serviceType as pickupPointName to close the order
            };

            $('body').trigger('FAN:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickupPointXBS', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxXBSExpress.trigger('click');
            } else {
                this.checkboxXBS.trigger('click');
            }

            const selectedStoreId = e.target.dataset.storeSap;

            const storeName = $(e.target).closest('.result').find('.js-pickup-name').text();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').text();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').text();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').text();

            $('.js-pickup-name-XBS').text(storeName);
            $('.js-pickup-address1-XBS').text(storeAddress);
            $('.js-pickup-address2-XBS').text(storeCity);
            $('.js-pickup-postalcode-XBS').text(postalCode);
            $('.js-pickup-sap-XBS').text(selectedStoreId);

            $('.js-select-pickup-XBS').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreId,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickup-infowindow-XBS', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxXBSExpress.trigger('click');
            } else {
                this.checkboxXBS.trigger('click');
            }

            const selectedStoreSap = e.target.dataset.storeSap;

            const $result = $('#pickupPointListXBS').find('.result').filter(`[data-store-sap="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').text();
            const storeAddress = $result.find('.js-pickup-address-row1').text();
            const storeCity = $result.find('.js-pickup-city').text();
            const postalCode = $result.find('.js-pickup-postalcode').text();

            $('.js-pickup-name-XBS').html(storeName);
            $('.js-pickup-address1-XBS').html(storeAddress);
            $('.js-pickup-address2-XBS').html(storeCity);
            $('.js-pickup-postalcode-XBS').html(postalCode);
            $('.js-pickup-sap-XBS').html(selectedStoreSap);
            $('.js-pickup-type-XBS').html(type);

            $('.js-select-pickup-XBS').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreSap,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });


        $('body').on('click', '.js-choose-pickupPointEVR', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxEVRExpress.click();
            } else {
                this.checkboxEVR.click();
            }

            const selectedStoreId = e.target.dataset.storeSap;

            const storeName = $(e.target).closest('.result').find('.js-pickup-name').html();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').html();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').html();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').html();
            const type = $(e.target).closest('.result').find('.js-pickup-type').html();

            $('.js-pickup-name-EVR').html(storeName);
            $('.js-pickup-address1-EVR').html(storeAddress);
            $('.js-pickup-address2-EVR').html(storeCity);
            $('.js-pickup-postalcode-EVR').html(postalCode);
            $('.js-pickup-sap-EVR').html(selectedStoreId);
            $('.js-pickup-type-EVR').html(type);

            $('.js-select-pickup-EVR').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreId,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                type: type,
                shippingMethodType: _self.selectedShippingMethodType
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });
        $('body').on('click', '.js-choose-pickupPointPTN', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxPTNExpress.click();
            } else {
                this.checkboxPTN.click();
            }

            const selectedStoreId = e.target.dataset.storeSap;

            const storeName = $(e.target).closest('.result').find('.js-pickup-name').html();
            const storeAddress = $(e.target).closest('.result').find('.js-pickup-address-row1').html();
            const storeCity = $(e.target).closest('.result').find('.js-pickup-city').html();
            const postalCode = $(e.target).closest('.result').find('.js-pickup-postalcode').html();
            const type = $(e.target).closest('.result').find('.js-pickup-type').html();

            $('.js-pickup-name-PTN').html(storeName);
            $('.js-pickup-address1-PTN').html(storeAddress);
            $('.js-pickup-address2-PTN').html(storeCity);
            $('.js-pickup-postalcode-PTN').html(postalCode);
            $('.js-pickup-sap-PTN').html(selectedStoreId);
            $('.js-pickup-type-PTN').html(type);

            $('.js-select-pickup-PTN').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreId,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                type: type,
                shippingMethodType: _self.selectedShippingMethodType
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickup-infowindow-EVR', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxEVRExpress.click();
            } else {
                this.checkboxEVR.click();
            }

            const selectedStoreSap = e.target.dataset.storeSap;

            const $result = $('#pickupPointListEVR').find('.result').filter(`[data-store-sap="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').html();
            const storeAddress = $result.find('.js-pickup-address-row1').html();
            const storeCity = $result.find('.js-pickup-city').html();
            const postalCode = $result.find('.js-pickup-postalcode').html();
            const type = $result.find('.js-pickup-type').html();

            $('.js-pickup-name-EVR').html(storeName);
            $('.js-pickup-address1-EVR').html(storeAddress);
            $('.js-pickup-address2-EVR').html(storeCity);
            $('.js-pickup-postalcode-EVR').html(postalCode);
            $('.js-pickup-sap-EVR').html(selectedStoreSap);
            $('.js-pickup-type-EVR').html(type);

            $('.js-select-pickup-EVR').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreSap,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                type: type,
                shippingMethodType: _self.selectedShippingMethodType
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });

        $('body').on('click', '.js-choose-pickup-infowindow-PTN', (e) => {
            if ($('.express-button-modal').hasClass('tingle-modal--visible')) {
                this.checkboxPTNExpress.click();
            } else {
                this.checkboxPTN.click();
            }

            const selectedStoreSap = e.target.dataset.storeSap;

            const $result = $('#pickupPointListPTN').find('.result').filter(`[data-store-sap="${selectedStoreSap}"]`);

            if (!$result.length) {
                return;
            }

            const storeName = $result.find('.js-pickup-name').html();
            const storeAddress = $result.find('.js-pickup-address-row1').html();
            const storeCity = $result.find('.js-pickup-city').html();
            const postalCode = $result.find('.js-pickup-postalcode').html();
            const type = $result.find('.js-pickup-type').html();

            $('.js-pickup-name-PTN').html(storeName);
            $('.js-pickup-address1-PTN').html(storeAddress);
            $('.js-pickup-address2-PTN').html(storeCity);
            $('.js-pickup-postalcode-PTN').html(postalCode);
            $('.js-pickup-sap-PTN').html(selectedStoreSap);
            $('.js-pickup-type-PTN').html(type);

            $('.js-select-pickup-PTN').addClass('hide');
            $('.cc-changePickup').removeClass('hide');

            $('.cc-selectedPickupRecap').removeClass('hide');

            if ((!$('.selectedPickupRecap').hasClass('hide')) || $('.js-select-pickup').hasClass('hide')) {
                $('.selectedPickupRecap').addClass('hide');
                $('.js-select-pickup').removeClass('hide');
            }

            const data = {
                number: selectedStoreSap,
                name: storeName,
                address1: storeAddress,
                city: storeCity,
                postalCode: postalCode,
                type: type,
                shippingMethodType: _self.selectedShippingMethodType
            };

            $('body').trigger('STANDARD:selectedPickup', data);
            this.modal.hide();
        });
    }

    scrollToMap (mapType) {
        const $map = this.$element.find('#map');
        $map.show();
        const targetElement = document.querySelector(`#js-pickupPointMap${mapType}`);
        if (targetElement) {
            targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }
    
    scrollToMapInPost () {
        const $map = this.$elementInPost.find('#pickupPointMapInPost');
        const $wrapper = $('#pickupPointInPost.pickuppoint-wrapper');
        $map.show();

        $wrapper.animate({
            scrollTop: $wrapper.get(0).scrollHeight
        });
    }

    scrollToMapPPL () {
        const $map = this.$elementPPL.find('#pickupPointMapPPL');
        const $wrapper = $('#pickupPointPPL.pickuppoint-wrapper');
        $map.show();

        $wrapper.animate({
            scrollTop: $wrapper.get(0).scrollHeight
        });
    }

    scrollToMapCLSS () {
        const $map = this.$elementCLSS.find('#pickupPointMapCLSS');
        const $wrapper = $('#pickupPointCLSS.pickuppoint-wrapper');
        $map.show();

        $wrapper.animate({
            scrollTop: $wrapper.get(0).scrollHeight
        });
    }

    scrollToMapDHL () {
        const $map = this.$elementDHL.find('#pickupPointMapDHL');
        const $wrapper = $('#pickupPointDHL.pickuppoint-wrapper');
        $map.show();

        $wrapper.animate({
            scrollTop: $wrapper.get(0).scrollHeight
        });
    }

    scrollToMapBRT () {
        const $map = this.$elementPPL.find('#pickupPointMapBRT');
        const $wrapper = $('#pickupPointBRT.pickuppoint-wrapper');
        $map.show();

        $wrapper.animate({
            scrollTop: $wrapper.get(0).scrollHeight
        });
    }

    scrollToMapDPD () {
        const $map = this.$elementDPD.find('#pickupPointMapDPD');
        const $wrapper = $('#pickupPointDPD.pickuppoint-wrapper');
        $map.show();

        $wrapper.animate({
            scrollTop: $wrapper.get(0).scrollHeight
        });
    }

    scrollToMapHermes () {
        const $map = this.$elementDPD.find('#pickupPointMapHermes');
        const $wrapper = $('#pickupPointHermes.pickuppoint-wrapper');
        $map.show();

        $wrapper.animate({
            scrollTop: $wrapper.get(0).scrollHeight
        });
    }

    addSearchListener2 () {
        $('body').on('keyup', '#pickupPointMapModal input[name="querypostal"]', (e) => {
            const $searchButton = $('#pickupPointMapModal').parent().find('[type="submit"]');

            if ($('#pickupPointMapModal input[name="querycity"]').val().length > 3 && $('#pickupPointMapModal input[name="querypostal"]').val().length > 4) {
                $searchButton.removeAttr('disabled');
            } else {
                $searchButton.attr('disabled', 'disabled');
            }
        });
    }

    getStores () {
        var _self = this;
        var city = $('#pickupPointMapModal input[name="querycity"]').val();
        var postcode = $('#pickupPointMapModal input[name="querypostal"]').val();
        var radiusValue = _self.$element
            .find(_self.radiusSelector)
            .filter(':checked')
            .val();
        var data = {
            city: city,
            postcode: postcode,
            radius: radiusValue
        };
        $.spinner().start();
        if (_self.url) {
            $.ajax({
                url: _self.url,
                type: 'get',
                data: data,
                dataType: 'json',
                success: function (res) {
                    if (!res.error) {
                        _self.handlePickupResults(res.stores, res.resources);
                    }
                }
            });
        }
    }
    handlePickupResults (stores, resources) {
        // Fit bounds to markers
        this.map.updateMarkers(stores, resources);

        // Update the pup text list
        const $target = $('#pickupPointList');
        $target.empty();

        if ($target.length && stores.length > 0) {
            $('.map-canvas').removeClass('hide');
            let html = `<p class="dark">${resources.summary.replace('RADIUS', resources.currentStep)}</p>`;
            const selectedStoreId = $('#pickUpPointNumber').val();
            let labelIndex = -1;
            if (stores.length) {
                stores.map((store) => {
                    const isSelected = store.sap == selectedStoreId;
                    labelIndex++;
                    html += this.renderResult(store, resources, isSelected, labelIndex);
                });
            }

            $target.html(html);
        }

        $(this.modal.$el).spinner().stop();
    }
    renderResult (data, resources, isSelected = false, labelIndex) {
        let buttonFragment = `<p class="small dark text-right"></p>`;
        buttonFragment = `<button class="button button--primary js-choose-pickup" data-store-id="${data.name}" data-store-sap="${data.sap}">${resources.select}</button>`;

        let labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let label = '';
        let increment = Math.floor(labelIndex >= labels.length ? labelIndex / labels.length : 0);
        let index = Math.floor(labelIndex > labels.length ? (labelIndex - Math.floor(labelIndex / labels.length).toFixed(0) * labels.length) : labelIndex);
        label = labels[index % labels.length] + (increment > 0 ? increment + '' : '');

        return `
            <div class="grid-x result ${isSelected ? 'result--selected' : ''}" data-store-id="${data.name}" data-store-sap="${data.sap}">
                <div class="cell shrink">
                    <i class="fas fa-lg fa-map-marker-alt" aria-hidden="true" role="presentation">
                        <span class="label-count small">${label}</span>
                    </i>
                </div>
                <div class="cell auto js-store-row">
                    <div class="store-details">
                        <p class="distance">
                            <span class="notranslate js-pickup-name dark">${data.name}</span>
                        </p>
                        <p>
                        <span class="notranslate js-pickup-address-row1 ">${data.street} ${data.house}</span>
                        </p>
                        <p>
                            <span class="notranslate js-pickup-city">${data.city}</span>, <span class="notranslate js-pickup-postalcode">${data.postcode}</span>
                        </p>
                    </div>
                    <div class="cell spacer small"></div>
                    <div class="cell grid-x">
                        <div class="cell small-6 align-self-middle">
                            <a target="_blank" class="uppercase fi-show-on-map dark force-hover" data-coords="${data.lat},${data.long}">${resources.showOnMap}</a>
                        </div>
                        <div class="cell small-4 text-right">
                            ${buttonFragment}
                        </div>
                    </div>
                    <div class="cell spacer"></div>
                </div>
            </div>`;
    }

    getStoresInPost () {
        var _self = this;
        var data = {
            lat: _self.coordinates.lat,
            long: _self.coordinates.long
        };
        $.spinner().start();
        if (_self.urlInpost) {
            $.ajax({
                url: _self.urlInpost,
                type: 'get',
                data: data,
                dataType: 'json',
                success: function (res) {
                    if (!res.error) {
                        _self.handlePickupResultsInPost(res.stores, res.resources);
                    }
                }
            });
        }
    }
    handlePickupResultsInPost (stores, resources) {
        // Fit bounds to markers
        this.map.updateMarkersInPost(stores, resources);

        // Update the pup text list
        const $target = $('#pickupPointListInPost');
        $target.empty();

        if ($target.length && stores.length > 0) {
            $('.map-canvas').removeClass('hide');
            let html = `<p class="dark">${resources.summary.replace('RADIUS', resources.currentStep)}</p>`;
            const selectedStoreId = $('#pickUpPointName').val();
            let labelIndex = -1;
            if (stores.length) {
                stores.map((store) => {
                    const isSelected = store.name == selectedStoreId;
                    labelIndex++;
                    html += this.renderResultInpost(store, resources, isSelected, labelIndex);
                });
            }

            $target.html(html);
        }

        $(this.modal.$el).spinner().stop();
    }
    renderResultInpost (data, resources, isSelected = false, labelIndex) {
        let buttonFragment = `<p class="small dark text-right"></p>`;
        buttonFragment = `<button class="button button--primary js-choose-pickupPointIN" data-store-id="${data.name}" data-store-sap="${data.sap}">${resources.select}</button>`;
        let labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let label = '';
        let increment = Math.floor(labelIndex >= labels.length ? labelIndex / labels.length : 0);
        let index = Math.floor(labelIndex > labels.length ? (labelIndex - Math.floor(labelIndex / labels.length).toFixed(0) * labels.length) : labelIndex);
        label = labels[index % labels.length] + (increment > 0 ? increment + '' : '');
        return `
            <div class="grid-x result ${isSelected ? 'result--selected' : ''}" data-store-id="${data.name}" data-store-sap="${data.sap}">
                <div class="cell shrink">
                    <i class="fas fa-lg fa-map-marker-alt" aria-hidden="true" role="presentation">
                        <span class="label-count small">${label}</span>
                    </i>
                </div>
                <div class="cell auto js-store-row">
                    <div class="store-details">
                        <p class="distance">
                            <span class="notranslate js-pickup-name dark">${data.name}</span>
                        </p>
                        <p>
                        <span class="notranslate js-pickup-address-row1 ">${data.street} ${data.house}</span>
                        </p>
                        <p>
                            <span class="notranslate js-pickup-city">${data.city}</span>, <span class="notranslate js-pickup-postalcode">${data.postcode}</span>
                        </p>
                    </div>
                    <div class="cell spacer small"></div>
                    <div class="cell grid-x">
                        <div class="cell small-6 align-self-middle">
                            <a target="_blank" class="uppercase fi-show-on-map-inpost dark force-hover" data-coords="${data.lat},${data.long}">${resources.showOnMap}</a>
                        </div>
                        <div class="cell small-4 text-right">
                            ${buttonFragment}
                        </div>
                    </div>
                    <div class="cell spacer"></div>
                </div>
            </div>`;
    }

    getStoresBRT (viewMore) {
        var _self = this;

        let dataContainer = $('#pickupPointBRT');

        let rad = 10;
        rad = viewMore ? (dataContainer.attr('data-next-step-pickup-point') ? parseInt(dataContainer.attr('data-next-step-pickup-point')) : parseInt(dataContainer.data('base-step-pickup-point'))) : (parseInt(dataContainer.data('base-step-pickup-point')) ? parseInt(dataContainer.data('base-step-pickup-point')) : 10);

        var data = {
            lat: _self.coordinates.lat.toFixed(8),
            long: _self.coordinates.long.toFixed(8),
            rad: rad
        };
        $.spinner().start();
        if (_self.urlBRT) {
            $.ajax({
                url: _self.urlBRT,
                type: 'get',
                data: data,
                dataType: 'json',
                success: function (res) {
                    if (!res.error) {
                        _self.handlePickupResultsBRT(res.stores, res.resources, res);
                    }
                }
            });
        }
    }
    handlePickupResultsBRT (stores, resources, result) {
        let dataContainer = $('#pickupPointBRT');
        dataContainer.attr('data-current-step-pickup-point', result.currentStep);
        dataContainer.attr('data-next-step-pickup-point', result.nextStep);
        // Fit bounds to markers
        this.map.updateMarkersBRT(stores, resources);

        // Update the pup text list
        const $target = $('#pickupPointListBRT');
        $target.empty();

        if ($target.length && stores.length > 0) {
            $('.map-canvas').removeClass('hide');
            let html = `<p class="dark">${resources.summary.replace('RADIUS', resources.currentStep)}</p>`;
            const selectedStoreId = $('#pickUpPointName').val();
            let labelIndex = -1;
            if (stores.length) {
                stores.map((store) => {
                    const isSelected = store.name == selectedStoreId;
                    labelIndex++;
                    html += this.renderResultBRT(store, resources, isSelected, labelIndex);
                });
                $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: stores[0].city });
            }

            if (result.showMoreEnabled) {
                html += `<div class="spacer medium"></div><div class="grid-x grid-margin-x text-center"><div class="cell"><button class="button button--secondary view-more-button-brt">${dataContainer.data('view-more-label')}</button><div></div>`;
            }

            $target.html(html);
        } else if ($target.length && stores.length === 0) {
            let html = `<p class="dark">${resources.summary}</p>`;
            $target.html(html);
        }

        $(this.modal.$el).spinner().stop();
    }

    renderResultBRT (data, resources, isSelected = false, labelIndex) {
        let buttonFragment = `<p class="small dark text-right"></p>`;
        buttonFragment = `<button class="button button--primary js-choose-pickupPointBRT" data-store-id="${data.name}" data-store-sap="${data.sap}">${resources.select}</button>`;
        let labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let label = '';
        let increment = Math.floor(labelIndex >= labels.length ? labelIndex / labels.length : 0);
        let index = Math.floor(labelIndex > labels.length ? (labelIndex - Math.floor(labelIndex / labels.length).toFixed(0) * labels.length) : labelIndex);
        label = labels[index % labels.length] + (increment > 0 ? increment + '' : '');
        return `
            <div class="grid-x result ${isSelected ? 'result--selected' : ''}" data-store-id="${data.name}" data-store-sap="${data.sap}">
                <div class="cell shrink">
                    <i class="fas fa-lg fa-map-marker-alt" aria-hidden="true" role="presentation">
                        <span class="label-count small">${label}</span>
                    </i>
                </div>
                <div class="cell auto js-store-row">
                    <div class="store-details">
                        <p class="distance">
                            <span class="notranslate js-pickup-name dark">${data.name}</span>
                        </p>
                        <p>
                        <span class="notranslate js-pickup-address-row1 ">${data.street} ${data.house}</span>
                        </p>
                        <p>
                            <span class="notranslate js-pickup-city">${data.city}</span>, <span class="notranslate js-pickup-postalcode">${data.postcode}</span>
                        </p>
                    </div>
                    <div class="cell spacer small"></div>
                    <div class="cell grid-x">
                        <div class="cell small-6 align-self-middle">
                            <a target="_blank" class="uppercase fi-show-on-map-brt dark force-hover" data-coords="${data.lat},${data.long}">${resources.showOnMap}</a>
                        </div>
                        <div class="cell small-4 text-right">
                            ${buttonFragment}
                        </div>
                    </div>
                    <div class="cell spacer"></div>
                </div>
            </div>`;
    }
    /**
     * Show the PUP popup
     */
    showPUPPopupListener () {
        var _self = this;
        const $searchButton = $('#pickupPointMapModal input[name="querycity"]').parent().find('[type="submit"]');
        $('body').on('click', '#pickupPointButton', function (e) {
            e.preventDefault();

            // create and open confirmation modal
            _self.modal = new ModalShowHide(_self.elementSelector);
            _self.modal.show();
            $('.map-canvas').addClass('hide');
            _self.getStores();

            $(_self.modal.modalBox).on('click', '.close, .btn-close', (e) => {
                e.preventDefault();
                _self.modal.hide();
            });

            _self.launch();
        });
        $('body').on('click', '#pickupPointButtonIN', function (e) {
            e.preventDefault();

            // create and open confirmation modal
            _self.modal = new ModalShowHide(_self.elementSelectorInPost);
            _self.modal.show();
            $('.map-canvas').addClass('hide');
            _self.getStoresInPost();

            $(_self.modal.modalBox).on('click', '.close, .btn-close', (e) => {
                e.preventDefault();
                _self.modal.hide();
            });

            _self.launchInPost();
            woosmapInitInPost();
        });

        $('body').on('click', '#pickupPointButtonPPL', function (e) {
            e.preventDefault();

            // create and open confirmation modal
            _self.modal = new ModalShowHide(_self.elementSelectorPPL);
            _self.modal.show();
            $('.map-canvas').addClass('hide');
            // _self.getStoresPPL();

            $(_self.modal.modalBox).on('click', '.close, .btn-close', (e) => {
                e.preventDefault();
                _self.modal.hide();
            });

            _self.launchPPL();
            woosmapInitPPL();
        });
        $('body').on('click', '#pickupPointButtonCLSS', function (e) {
            e.preventDefault();

            // create and open confirmation modal
            _self.modal = new ModalShowHide(_self.elementSelectorCLSS);
            _self.modal.show();
            $('.map-canvas').addClass('hide');
            // _self.getStoresPPL();

            $(_self.modal.modalBox).on('click', '.close, .btn-close', (e) => {
                e.preventDefault();
                _self.modal.hide();
            });

            _self.launchCLSS();
            woosmapInitCollissimo();
        });

        $('body').on('click', '#pickupPointButtonDHL', function (e) {
            e.preventDefault();

            // create and open confirmation modal
            _self.modal = new ModalShowHide(_self.elementSelectorDHL);
            _self.modal.show();
            $('.map-canvas').addClass('hide');
            // _self.getStoresDHL();

            $(_self.modal.modalBox).on('click', '.close, .btn-close', (e) => {
                e.preventDefault();
                _self.modal.hide();
            });

            _self.launchDHL();
            woosmapInitDHL();
        });

        $('body').on('click', '#pickupPointButtonBRT', function (e) {
            e.preventDefault();

            // create and open confirmation modal
            _self.modal = new ModalShowHide(_self.elementSelectorBRT);
            _self.modal.show();
            $('.map-canvas').addClass('hide');

            $(_self.modal.modalBox).on('click', '.close, .btn-close', (e) => {
                e.preventDefault();
                _self.modal.hide();
            });

            _self.launchBRT();
            woosmapInitBRT();
        });

        $('.pickuppoint').on('click', '.view-more-button-brt', function (e) {
            _self.getStoresBRT('true');
        });

        $('body').on('click', '#pickupPointButtonHermes', function (e) {
            e.preventDefault();

            // create and open confirmation modal
            _self.modal = new ModalShowHide(_self.elementSelectorHermes);
            _self.modal.show();
            $('.map-canvas').addClass('hide');
            // _self.getStoresDPD();

            $(_self.modal.modalBox).on('click', '.close, .btn-close', (e) => {
                e.preventDefault();
                _self.modal.hide();
            });

            _self.launchHermes();
            woosmapInitHermes();
        });

        $('.pickup-input-group-button').on('click', function (e) {
            e.preventDefault();
            _self.getStores();
        });

        $('.pickup-input-group-button-InPost').on('click', function (e) {
            e.preventDefault();
            _self.getCoordsFromCity();
        });

        $('.pickup-input-group-button-PPL').on('click', function (e) {
            e.preventDefault();
            _self.getCoordsFromCityPPL();
        });

        $('.pickup-input-group-button-DHL').on('click', function (e) {
            e.preventDefault();
            _self.getCoordsFromCityDHL();
        });

        $('.pickup-input-group-button-BRT').on('click', function (e) {
            e.preventDefault();
            _self.getCoordsFromCityBRT();
        });

        $('.pickup-input-group-button-DPD').on('click', function (e) {
            e.preventDefault();
            _self.getCoordsFromCityDPD();
        });

        $('.pickup-input-group-button-hermes').on('click', function (e) {
            e.preventDefault();
            _self.getCoordsFromCityHermes();
        });

        // TODO - Attach new BFF PickupPoints to this listener
        $('body').on('click', '#pickupPointButtonBPOST, #pickupPointButtonPDB, #pickupPointButtonEVR, #pickupPointButtonPTN, #pickupPointButtonEST, #pickupPointButtonDEL, #pickupPointButtonCTT, #pickupPointButtonGLS, #pickupPointButtonMRE, #pickupPointButtonGLSHU, #pickupPointButtonDPD, #pickupPointButtonFAN, #pickupPointButtonXBS, .js-select-pickup.pickup-pointd-btn', function (e) {
            e.preventDefault();

            _self.selectedShippingMethodType = $(this).data('shippingMethodType');
            const mapKey = `elementSelector${_self.selectedShippingMethodType}`;

            // create and open confirmation modal
            _self.modal = new ModalShowHide(_self[mapKey]);
            _self.modal.show();

            $(_self.modal.modalBox).on('click', '.close, .btn-close', (e) => {
                e.preventDefault();
                _self.modal.hide();
            });

            _self.selectedShippingMethodId = $(this).data('shippingId');

            _self.launchPudoBFF();

            woosmapInitPudoBFF(_self.selectedShippingMethodType);
        });

        $('.pickup-input-group-button-BPOST, .pickup-input-group-button-PDB, .pickup-input-group-button-EVR, .pickup-input-group-button-PTN, .pickup-input-group-button-EST, .pickup-input-group-button-DEL, .pickup-input-group-button-GLS, .pickup-input-group-button-MRE, .pickup-input-group-button-GLSHU, .pickup-input-group-button-DPD, .pickup-input-group-button-FAN, .pickup-input-group-button-XBS, .pickup-input-group-button-CTT').on('click', function (e) {
            e.preventDefault();
        });

        $('.pickuppoint').on('click', '.view-more-button-BPOST, .view-more-button-PDB, .view-more-button-EVR, .view-more-button-PTN, .view-more-button-EST, .view-more-button-DEL, .view-more-button-GLS, .view-more-button-MRE, .view-more-button-GLSHU, .view-more-button-DPD, .view-more-button-FAN, .view-more-button-XBS, .view-more-button-CTT ', function (e) {
            _self.getStoresFromBFF(true);
        });
    }

    GetPickupPointDetailsCall (data) {
        var _self = this;
        // Load pup info in details section
        $('.js-pup-details-name').text(data.name);
        $('.js-pup-details-city').text(data.city);
        $('.js-pup-details-address').text(data.street);
        $('.js-pup-details-house').text(data.house);

        if ('phones' in data && data.phones.length > 0) {
            var phonesList = ``;
            for (let i = 0; i < data.phones.length; i++) {
                const currentPhone = data.phones[i];
                phonesList += currentPhone + `<br>`;
            }
            $('.js-pup-details-phones').html(phonesList);
            $('.js-pup-details-phones-section').removeClass('hide');
        } else {
            $('.js-pup-details-phones').html('');
            $('.js-pup-details-phones-section').addClass('hide');
        }
        // Update fields for the pup selection
        $('#selectPickupPointButton').data('address1', data.street + ', ' + data.house);
        $('#selectPickupPointButton').data('city', data.city);

        $('#selectPickupPointButton').data('street', data.street);
        $('#selectPickupPointButton').data('houseNumber', data.house);
        $('#selectPickupPointButton').data('pickUpPointName', data.name);
        $('#selectPickupPointButton').data('methodTypeCode', 'pickup');
        // Center map on pup
        _self.centerOnPickupPoint(data.latitude, data.longitude);
        // Show details section
    }

    mapListener () {
        var _self = this;
        // Handle Geocoding update event
        $('body').on('pickupPointGeocode:update', this.$element, (e, res) => {
            if (res.success) {
                // Set active coordinates according to Google Geocoding's response
                this.coordinates.lat = res.data.lat;
                this.coordinates.long = res.data.long;
                this.locality = res.data.locality;
                this.zipcode = res.data.zipcode;
                // Update map with current coordinates
                this.map.updateCoordinates(this.coordinates);
                this.getStoresInPost();
                this.getStoresPPL();
                if ($('#pickupPointDHL').closest('.tingle-modal--visible').length) {
                    this.getStoresDHL();
                } else if ($('#pickupPointDPD').closest('.tingle-modal--visible').length) {
                    this.getStoresFromBFF();
                }
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Google failed: ' + res.status);
            }
        });
        // Click on marker
        $('body').on('pickuppoint:clickOnMarker', function (e, id) {
            _self.GetPickupPointDetailsCall(id);
        });
    }

    getCoordsFromCity () {
        const query = $('#pickupPointInPost input[name="query"]').val();
        var geocode = this.map.geocode(query, this.countryCode, this.$element);
        if (geocode) {
            this.coordinates = {
                lat: geocode.lat,
                long: geocode.long
            };
        }
    }

    getCoordsFromCityPPL () {
        const query = $('#pickupPointPPL input[name="query"]').val();
        this.queryPPL = query;
        var geocode = this.map.geocode(query, this.countryCode, this.$element);
        if (geocode) {
            this.coordinates = {
                lat: geocode.lat,
                long: geocode.long
            };
        }
    }

    getCoordsFromCityDHL () {
        const query = $('#pickupPointDHL input[name="query"]').val();
        this.queryDHL = query;
        var geocode = this.map.geocode(query, this.countryCode, this.$element);
        if (geocode) {
            this.coordinates = {
                lat: geocode.lat,
                long: geocode.long
            };
        }
    }

    getCoordsFromCityBRT () {
        const query = $('#pickupPointBRT input[name="query"]').val();
        this.queryPPL = query;
        var geocode = this.map.geocode(query, this.countryCode, this.$element);
        if (geocode) {
            this.coordinates = {
                lat: geocode.lat,
                long: geocode.long
            };
        }
    }

    getCoordsFromCityDPD () {
        const query = $('#pickupPointDPD input[name="query"]').val();
        this.queryDPD = query;
        var geocode = this.map.geocode(query, this.countryCode, this.$element);
        if (geocode) {
            this.coordinates = {
                lat: geocode.lat,
                long: geocode.long
            };
        }
    }

    getCoordsFromCityHermes () {
        const query = $('#pickupPointHermes input[name="query"]').val();
        this.queryHermes = query;
        var geocode = this.map.geocode(query, this.countryCode, this.$element);
        if (geocode) {
            this.coordinates = {
                lat: geocode.lat,
                long: geocode.long
            };
        }
    }

    detectLocationPickupPoint () {
        getPosition()
            .then((position) => {
                this.isGeolocalized = true;
                // Set active coordinates according to the browser's navigator
                this.coordinates.lat = position.coords.latitude;
                this.coordinates.long = position.coords.longitude;

                this.map.updateCoordinates(this.coordinates);
                this.getStoresInPost();
                this.getStoresPPL();
                this.getStoresCLSS();
                if ($('#pickupPointBRT').closest('.tingle-modal--visible').length) {
                    this.getStoresBRT(false);
                } else if ($('#pickupPointDHL').closest('.tingle-modal--visible').length) {
                    this.getStoresDHL();
                } else if ($('#pickupPointDPD').closest('.tingle-modal--visible').length) {
                    this.getStoresFromBFF();
                } else if ($('#pickupPointHermes').closest('.tingle-modal--visible').length) {
                    this.getStoresHermes();
                } else if ($('#pickupPointBPOST').closest('.tingle-modal--visible').length || $('#pickupPointDEL').closest('.tingle-modal--visible').length || $('#pickupPointGLS').closest('.tingle-modal--visible').length || $('#pickupPointCTT ').closest('.tingle-modal--visible').length) {
                    $.spinner().stop();
                    this.zipcode = '';
                } else if ($('#pickupPointPDB').closest('.tingle-modal--visible').length) {
                    $.spinner().stop();
                    this.zipcode = '';
                    this.serviceType = $('#pickupPointPDB').find('input[name="pickup-point-service-type"]:checked').attr('id');
                } else if ($('#pickupPointEVR').closest('.tingle-modal--visible').length) {
                    $.spinner().stop();
                } else if ($('#pickupPointPTN').closest('.tingle-modal--visible').length) {
                    this.getStoresFromBFF();
                } else if ($('#pickupPointEST').closest('.tingle-modal--visible').length) {
                    $.spinner().stop();
                    this.serviceType = $('#pickupPointEST').find('input[name="pickup-point-service-type"]:checked').attr('id');
                    this.getStoresFromBFF();
                } else if ($('#pickupPointMRE').closest('.tingle-modal--visible').length) {
                    $.spinner().stop();
                    this.getStoresFromBFF();
                } else if ($('#pickupPointGLSHU').closest('.tingle-modal--visible').length) {
                    $.spinner().stop();
                    this.getStoresFromBFF();
                } else if ($('#pickupPointFAN').closest('.tingle-modal--visible').length) {
                    this.serviceType = $('#pickupPointFAN').find('input[name="pickup-point-service-type"]:checked').attr('id');
                    this.getStoresFromBFF();
                } else if ($('#pickupPointXBS').closest('.tingle-modal--visible').length) {
                    this.getStoresFromBFF();
                }

                const query = this.coordinates;
                this.map.geocode(query);
            })
            .catch((err) => {
                // User geolocation not available, log error to the console as warning
                console.warn(err.message);
                $('#findinstore-usecurrentposition').addClass('disabled');
                $('#PPL-usecurrentposition').addClass('disabled');
                $('#CLSS-usecurrentposition').addClass('disabled');
                $('#BRT-usecurrentposition').addClass('disabled');
                $('#DHL-usecurrentposition').addClass('disabled');
                $('#DPD-usecurrentposition').addClass('disabled');
                $('#hermes-usecurrentposition').addClass('disabled');
                $('#js-useCurrentPositionEVR').addClass('disabled');
                $('#js-useCurrentPositionPTN').addClass('disabled');
                $('#js-useCurrentPositionEST').addClass('disabled');
            });
    }

    launch () {
        // Only initialize Google's map once and on-demand
        if (!this.wasMapInitialized) {
            this.initMap();
        }

        // Update map coordinates
        this.map.updateCoordinates(this.coordinates);
    }

    launchInPost () {
        // Only initialize Google's map once and on-demand
        if (!this.wasMapInitializedInPost) {
            this.initMapInPost();
        }

        // Update map coordinates
        this.map.updateCoordinates(this.coordinates);
    }

    launchPPL () {
        // Only initialize Google's map once and on-demand
        if (!this.wasMapInitializedPPL) {
            this.initMapPPL();
        }

        // If no coordinates are set, attempt to locate user and get stores
        if (!this.hasCoordinates()) {
            this.detectLocationPickupPoint();
        } else {
            // Otherwise, just get the stores with the current information
            this.getStoresPPL();
        }
    }

    launchCLSS () {
        // Only initialize Google's map once and on-demand
        if (!this.wasMapInitializedCLSS) {
            this.initMapCLSS();
        }

        // If no coordinates are set, attempt to locate user and get stores
        if (!this.hasCoordinates()) {
            this.detectLocationPickupPoint();
        } else {
            // Otherwise, just get the stores with the current information
            this.getStoresCLSS();
        }
    }

    launchDHL () {
        // Only initialize Google's map once and on-demand
        if (!this.wasMapInitializedDHL) {
            this.initMapDHL();
        }

        // If no coordinates are set, attempt to locate user and get stores
        if (!this.hasCoordinates()) {
            this.detectLocationPickupPoint();
        } else {
            // Otherwise, just get the stores with the current information
            this.getStoresDHL();
        }
    }

    launchBRT () {
        // Only initialize Google's map once and on-demand
        if (!this.wasMapInitializedBRT) {
            this.initMapBRT();
        }

        // If no coordinates are set, attempt to locate user and get stores
        if (!this.hasCoordinates()) {
            this.detectLocationPickupPoint();
        } else {
            // Otherwise, just get the stores with the current information
            this.getStoresBRT(false);
        }
    }

    launchDPD () {
        // Only initialize Google's map once and on-demand
        if (!this.wasMapInitializedDPD) {
            this.initMapDPD();
        }

        // If no coordinates are set, attempt to locate user and get stores
        if (!this.hasCoordinates()) {
            this.detectLocationPickupPoint();
        } else {
            // Otherwise, just get the stores with the current information
            this.getStoresDPD();
        }
    }

    launchHermes () {
        // Only initialize Google's map once and on-demand
        if (!this.wasMapInitializedHermes) {
            this.initMapHermes();
        }

        // If no coordinates are set, attempt to locate user and get stores
        if (!this.hasCoordinates()) {
            this.detectLocationPickupPoint();
        } else {
            // Otherwise, just get the stores with the current information
            this.getStoresHermes();
        }
    }

    centerOnPickupPoint (lat, long) {
        if (lat && long) {
            this.coordinates = {
                lat: lat,
                long: long
            };

            // Update map coordinates
            this.map.centerMapOnCoordinates({ lat: lat, lng: long }, 16);
        }
    }

    /**
     * Create new Google Map with target and initial center on 0, 0
     */
    initMap () {
        this.map = new Map(this.$element.find('#pickupPointMap'), [this.coordinates.lat, this.coordinates.long]);
        this.map.init();
        this.wasMapInitialized = true;
    }

    initMapInPost () {
        this.map = new Map(this.$elementInPost.find('#pickupPointMapInPost'), [this.coordinates.lat, this.coordinates.long]);
        this.map.init();
        this.wasMapInitializedInPost = true;
    }

    initMapPPL () {
        // Create new Google Map with target and initial center on IP-detected geolocation
        let initialCoordinates = [0, 0];
        const initialCoordinatesString = $('#pickupPointPPL[data-geolocation]').data('geolocation');

        if (initialCoordinatesString.length) {
            initialCoordinates = initialCoordinatesString.split(',');
        }

        this.map = new Map(this.$elementPPL.find('#pickupPointMapPPL'), [Number(initialCoordinates[0]), Number(initialCoordinates[1])]);
        this.map.init();
        this.wasMapInitializedPPL = true;
    }

    initMapCLSS () {
        // Create new Google Map with target and initial center on IP-detected geolocation
        let initialCoordinates = [0, 0];
        const initialCoordinatesString = $('#pickupPointCLSS[data-geolocation]').data('geolocation');

        if (initialCoordinatesString.length) {
            initialCoordinates = initialCoordinatesString.split(',');
        }

        this.map = new Map(this.$elementCLSS.find('#pickupPointMapCLSS'), [Number(initialCoordinates[0]), Number(initialCoordinates[1])]);
        this.map.init();
        this.wasMapInitializedCLSS = true;
    }

    initMapBRT () {
        let initialCoordinates = [0, 0];
        const initialCoordinatesString = $('#pickupPointBRT[data-geolocation]').data('geolocation');

        if (initialCoordinatesString.length) {
            initialCoordinates = initialCoordinatesString.split(',');
        }

        this.map = new Map(this.$elementBRT.find('#pickupPointMapBRT'), [Number(initialCoordinates[0]), Number(initialCoordinates[1])]);
        this.map.init();
        this.wasMapInitializedBRT = true;
    }

    getStoresCLSS () {
        var _self = this;
        var data = {
            query: _self.queryPPL,
            zipcode: _self.zipcode,
            locality: _self.locality,
            lat: _self.coordinates.lat,
            long: _self.coordinates.long,
            countryCode: _self.countryCode,
            address: _self.addressComponent
        };
        $.spinner().start();
        if (_self.urlCLSS) {
            $.ajax({
                url: _self.urlCLSS,
                type: 'post',
                data: data,
                dataType: 'json',
                success: function (res) {
                    if (!res.error) {
                        _self.handlePickupResultsCLSS(res.stores, res.resources);
                    }
                }
            });
        }
    }

    getStoresPPL () {
        var _self = this;
        var data = {
            query: _self.queryPPL,
            zipcode: _self.zipcode,
            locality: _self.locality,
            lat: _self.coordinates.lat,
            long: _self.coordinates.long
        };
        $.spinner().start();
        if (_self.urlPPL) {
            $.ajax({
                url: _self.urlPPL,
                type: 'post',
                data: data,
                dataType: 'json',
                success: function (res) {
                    if (!res.error) {
                        _self.handlePickupResultsPPL(res.stores, res.resources);
                    }
                }
            });
        }
    }

    handlePickupResultsPPL (stores, resources) {
        // Fit bounds to markers
        this.map.updateMarkersPPL(stores, resources);

        // Update the pup text list
        const $target = $('#pickupPointListPPL');
        $target.empty();

        if ($target.length) {
            $('.map-canvas').removeClass('hide');
            let html = `<p class="dark">${resources && 'summary' in resources && resources.summary ? resources.summary : ''}</p>`;
            const selectedStoreId = $('#pickUpPointName').val();
            let labelIndex = -1;
            if (stores.length) {
                stores.map((store) => {
                    const isSelected = store.name == selectedStoreId;
                    labelIndex++;
                    html += this.renderResultPPL(store, resources, isSelected, labelIndex);
                });
            }

            $target.html(html);
        }

        $(this.modal.$el).spinner().stop();
    }

    handlePickupResultsCLSS (stores, resources) {
        // Fit bounds to markers
        this.map.updateMarkersCLSS(stores, resources);

        // Update the pup text list
        const $target = $('#pickupPointListCLSS');
        $target.empty();

        if ($target.length) {
            $('.map-canvas').removeClass('hide');
            let html = `<p class="dark">${resources && 'summary' in resources && resources.summary ? resources.summary : ''}</p>`;
            const selectedStoreId = $('#pickUpPointName').val();
            let labelIndex = -1;
            if (stores.length) {
                stores.map((store) => {
                    const isSelected = store.name == selectedStoreId;
                    labelIndex++;
                    html += this.renderResultCLSS(store, resources, isSelected, labelIndex);
                });
            }

            $target.html(html);
        }

        $(this.modal.$el).spinner().stop();
    }

    renderResultPPL (data, resources, isSelected = false, labelIndex) {
        let buttonFragment = `<p class="small dark text-right"></p>`;
        buttonFragment = `<button class="button button--primary js-choose-pickupPointPPL" data-store-id="${data.name}" data-store-sap="${data.sap}">${resources.select}</button>`;
        let labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let label = '';
        let increment = Math.floor(labelIndex >= labels.length ? labelIndex / labels.length : 0);
        let index = Math.floor(labelIndex > labels.length ? (labelIndex - Math.floor(labelIndex / labels.length).toFixed(0) * labels.length) : labelIndex);
        label = labels[index % labels.length] + (increment > 0 ? increment + '' : '');
        return `
            <div class="grid-x result ${isSelected ? 'result--selected' : ''}" data-store-id="${data.name}" data-store-sap="${data.sap}">
                <div class="cell shrink">
                    <i class="fas fa-lg fa-map-marker-alt" aria-hidden="true" role="presentation">
                        <span class="label-count small">${label}</span>
                    </i>
                </div>
                <div class="cell auto js-store-row">
                    <div class="store-details">
                        <p class="distance">
                            <span class="notranslate js-pickup-name dark">${data.name}</span>
                        </p>
                        <p>
                        <span class="notranslate js-pickup-address-row1 ">${data.street} ${data.house}</span>
                        </p>
                        <p>
                            <span class="notranslate js-pickup-city">${data.city}</span>, <span class="notranslate js-pickup-postalcode">${data.postcode}</span>
                        </p>
                    </div>
                    <div class="cell spacer small"></div>
                    <div class="cell grid-x">
                        <div class="cell small-6 align-self-middle">
                            <a target="_blank" class="uppercase fi-show-on-map-ppl dark force-hover" data-coords="${data.lat},${data.long}">${resources.showOnMap}</a>
                        </div>
                        <div class="cell small-4 text-right">
                            ${buttonFragment}
                        </div>
                    </div>
                    <div class="cell spacer"></div>
                </div>
            </div>`;
    }

    renderResultCLSS (data, resources, isSelected = false, labelIndex) {
        let buttonFragment = `<p class="small dark text-right"></p>`;
        buttonFragment = `<button class="button button--primary js-choose-pickupPointCLSS" data-store-id="${data.name}" data-store-sap="${data.sap}">${resources.select}</button>`;
        let labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let label = '';
        let increment = Math.floor(labelIndex >= labels.length ? labelIndex / labels.length : 0);
        let index = Math.floor(labelIndex > labels.length ? (labelIndex - Math.floor(labelIndex / labels.length).toFixed(0) * labels.length) : labelIndex);
        label = labels[index % labels.length] + (increment > 0 ? increment + '' : '');
        return `
            <div class="grid-x result ${isSelected ? 'result--selected' : ''}" data-store-id="${data.name}" data-store-sap="${data.sap}">
                <div class="cell shrink">
                    <i class="fas fa-lg fa-map-marker-alt" aria-hidden="true" role="presentation">
                        <span class="label-count small">${label}</span>
                    </i>
                </div>
                <div class="cell auto js-store-row">
                    <div class="store-details">
                        <p class="distance">
                            <span class="notranslate js-pickup-name dark">${data.name}</span>
                        </p>
                        <p>
                        <span class="notranslate js-pickup-address-row1 ">${data.street} ${data.house}</span>
                        </p>
                        <p>
                            <span class="notranslate js-pickup-city">${data.city}</span>, <span class="notranslate js-pickup-postalcode">${data.postcode}</span>
                            <span class="hide notranslate js-pickup-type">${data.typeDePoint}</span>
                        </p>
                    </div>
                    <div class="cell spacer small"></div>
                    <div class="cell grid-x">
                        <div class="cell small-6 align-self-middle">
                            <a target="_blank" class="uppercase fi-show-on-map-CLSS dark force-hover" data-coords="${data.lat},${data.long}">${resources.showOnMap}</a>
                        </div>
                        <div class="cell small-4 text-right">
                            ${buttonFragment}
                        </div>
                    </div>
                    <div class="cell spacer"></div>
                </div>
            </div>`;
    }

    initMapDHL () {
        // Create new Google Map with target and initial center on IP-detected geolocation
        let initialCoordinates = [0, 0];
        const initialCoordinatesString = $('#pickupPointDHL[data-geolocation]').data('geolocation');

        if (initialCoordinatesString.length) {
            initialCoordinates = initialCoordinatesString.split(',');
        }

        this.map = new Map(this.$elementDHL.find('#pickupPointMapDHL'), [Number(initialCoordinates[0]), Number(initialCoordinates[1])]);
        this.map.init();
        this.wasMapInitializedDHL = true;
    }

    getStoresDHL (limit = true) {
        var _self = this;
        var data = {
            lat: _self.coordinates.lat,
            lon: _self.coordinates.long,
            limit: limit ? 15 : 50
        };
        $.spinner().start();
        if (_self.urlDHL) {
            $.ajax({
                url: _self.urlDHL,
                type: 'get',
                data: data,
                dataType: 'json',
                success: function (res) {
                    if (!res.error) {
                        _self.handlePickupResultsDHL(res.stores, res.resources, res.showMoreEnabled);
                    }
                }
            });
        }
    }

    observeViewMoreDHL () {
        var _self = this;
        $('#pickupPointDHL').on('click', '.view-more-button-DHL', function (e) {
            _self.getStoresDHL(false);
        });
    }

    handlePickupResultsDHL (stores, resources, showMoreEnabled) {
        // Fit bounds to markers
        this.map.updateMarkersDHL(stores, resources);

        // Update the pup text list
        const $target = $('#pickupPointListDHL');
        $target.empty();
        let dataContainer = $('#pickupPointDHL');

        if ($target.length) {
            $('.map-canvas').removeClass('hide');
            let html = `<p class="dark">${resources && 'summary' in resources && resources.summary ? resources.summary : ''}</p>`;
            const selectedStoreId = $('#pickUpPointName').val();
            let labelIndex = -1;
            if (stores.length) {
                stores.map((store) => {
                    const isSelected = store.name == selectedStoreId;
                    labelIndex++;
                    html += this.renderResultDHL(store, resources, isSelected, labelIndex);
                });
                if (showMoreEnabled) {
                    html += `<div class="spacer medium"></div><div class="grid-x grid-margin-x text-center"><div class="cell"><button class="button button--secondary view-more-button-DHL ">${dataContainer.data('view-more-label')}</button><div></div>`;
                }
            }

            $target.html(html);
        }

        $(this.modal.$el).spinner().stop();
    }

    renderResultDHL (data, resources, isSelected = false, labelIndex) {
        let buttonFragment = `<p class="small dark text-right"></p>`;
        buttonFragment = `<button class="button button--primary js-choose-pickupPointDHL" data-store-id="${data.name}" data-store-sap="${data.sap}">${resources.select}</button>`;
        let labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let label = '';
        let increment = Math.floor(labelIndex >= labels.length ? labelIndex / labels.length : 0);
        let index = Math.floor(labelIndex > labels.length ? (labelIndex - Math.floor(labelIndex / labels.length).toFixed(0) * labels.length) : labelIndex);
        label = labels[index % labels.length] + (increment > 0 ? increment + '' : '');
        return `
            <div class="grid-x result ${isSelected ? 'result--selected' : ''}" data-store-id="${data.name}" data-store-sap="${data.sap}" data-packstation="${data.isPackstation}">
                <div class="cell shrink">
                    <i class="fas fa-lg fa-map-marker-alt" aria-hidden="true" role="presentation">
                        <span class="label-count small">${label}</span>
                    </i>
                </div>
                <div class="cell auto js-store-row">
                    <div class="store-details">
                        <p class="distance">
                            <span class="notranslate js-pickup-name dark">${data.name}</span>
                        </p>
                        <p>
                        <span class="notranslate js-pickup-address-row1 ">${data.street}</span>
                        </p>
                        <p>
                            <span class="notranslate js-pickup-city">${data.city}</span>, <span class="notranslate js-pickup-postalcode">${data.postcode}</span>
                        </p>
                    </div>
                    <div class="cell spacer small"></div>
                    <div class="cell grid-x">
                        <div class="cell small-6 align-self-middle">
                            <a target="_blank" class="uppercase fi-show-on-map-dhl dark force-hover" data-coords="${data.lat},${data.long}">${resources.showOnMap}</a>
                        </div>
                        <div class="cell small-4 text-right">
                            ${buttonFragment}
                        </div>
                    </div>
                    <div class="cell spacer"></div>
                </div>
            </div>`;
    }

    initMapDPD () {
        // Create new Google Map with target and initial center on IP-detected geolocation
        let initialCoordinates = [0, 0];
        const initialCoordinatesString = $('#pickupPointDPD[data-geolocation]').data('geolocation');

        if (initialCoordinatesString.length) {
            initialCoordinates = initialCoordinatesString.split(',');
        }

        this.map = new Map(this.$elementDPD.find('#pickupPointMapDPD'), [Number(initialCoordinates[0]), Number(initialCoordinates[1])]);
        this.map.init();
        this.wasMapInitializedDPD = true;
    }

    getStoresDPD (limit = true) {
        var _self = this;
        var data = {
            lat: _self.coordinates.lat,
            lon: _self.coordinates.long,
            limit: limit ? 15 : 50
        };
        $.spinner().start();
        if (_self.urlDPD) {
            $.ajax({
                url: _self.urlDPD,
                type: 'get',
                data: data,
                dataType: 'json',
                success: function (res) {
                    if (!res.error) {
                        _self.handlePickupResultsDPD(res.stores, res.resources, res.showMoreEnabled);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    }

    observeViewMoreDPD () {
        var _self = this;
        $('#pickupPointDPD').on('click', '.view-more-button-DPD', function (e) {
            _self.getStoresDPD(false);
        });
    }

    handlePickupResultsDPD (stores, resources, showMoreEnabled) {
        // Fit bounds to markers
        this.map.updateMarkersDPD(stores, resources);

        // Update the pup text list
        const $target = $('#pickupPointListDPD');
        $target.empty();
        let dataContainer = $('#pickupPointDPD');

        if ($target.length) {
            $('.map-canvas').removeClass('hide');
            let html = `<p class="dark">${resources && 'summary' in resources && resources.summary ? resources.summary : ''}</p>`;
            const selectedStoreId = $('#pickUpPointName').val();
            let labelIndex = -1;
            if (stores.length) {
                stores.map((store) => {
                    const isSelected = store.name == selectedStoreId;
                    labelIndex++;
                    html += this.renderResultDPD(store, resources, isSelected, labelIndex);
                });
                if (showMoreEnabled) {
                    html += `<div class="spacer medium"></div><div class="grid-x grid-margin-x text-center"><div class="cell"><button class="button button--secondary view-more-button-DPD ">${dataContainer.data('view-more-label')}</button><div></div>`;
                }
            }

            $target.html(html);
        }

        $(this.modal.$el).spinner().stop();
    }

    renderResultDPD (data, resources, isSelected = false, labelIndex) {
        let buttonFragment = `<p class="small dark text-right"></p>`;
        buttonFragment = `<button class="button button--primary js-choose-pickupPointDPD" data-store-id="${data.name}" data-store-sap="${data.sap}">${resources.select}</button>`;
        let labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let label = '';
        let increment = Math.floor(labelIndex >= labels.length ? labelIndex / labels.length : 0);
        let index = Math.floor(labelIndex > labels.length ? (labelIndex - Math.floor(labelIndex / labels.length).toFixed(0) * labels.length) : labelIndex);
        label = labels[index % labels.length] + (increment > 0 ? increment + '' : '');
        return `
            <div class="grid-x result ${isSelected ? 'result--selected' : ''}" data-store-id="${data.name}" data-store-sap="${data.sap}">
                <div class="cell shrink">
                    <i class="fas fa-lg fa-map-marker-alt" aria-hidden="true" role="presentation">
                        <span class="label-count small">${label}</span>
                    </i>
                </div>
                <div class="cell auto js-store-row">
                    <div class="store-details">
                        <p class="distance">
                            <span class="notranslate js-pickup-name dark">${data.name}</span>
                        </p>
                        <p>
                        <span class="notranslate js-pickup-address-row1 ">${data.street}</span>
                        </p>
                        <p>
                            <span class="notranslate js-pickup-city">${data.city}</span>, <span class="notranslate js-pickup-postalcode">${data.postcode}</span>
                        </p>
                    </div>
                    <div class="cell spacer small"></div>
                    <div class="cell grid-x">
                        <div class="cell small-6 align-self-middle">
                            <a target="_blank" class="uppercase fi-show-on-map-dpd dark force-hover" data-coords="${data.lat},${data.long}">${resources.showOnMap}</a>
                        </div>
                        <div class="cell small-4 text-right">
                            ${buttonFragment}
                        </div>
                    </div>
                    <div class="cell spacer"></div>
                </div>
            </div>`;
    }

    initMapHermes () {
        // Create new Google Map with target and initial center on IP-detected geolocation
        let initialCoordinates = [0, 0];
        const initialCoordinatesString = $('#pickupPointHermes[data-geolocation]').data('geolocation');

        if (initialCoordinatesString.length) {
            initialCoordinates = initialCoordinatesString.split(',');
        }

        this.map = new Map(this.$elementHermes.find('#pickupPointMapHermes'), [Number(initialCoordinates[0]), Number(initialCoordinates[1])]);
        this.map.init();
        this.wasMapInitializedHermes = true;
    }

    getStoresHermes (limit = true) {
        var _self = this;
        var radius = limit ? this.$elementHermes.data('baseStep') : this.$elementHermes.data('nextStepPickupPoint');
        var data = {
            lat: _self.coordinates.lat,
            lon: _self.coordinates.long,
            limit: radius
        };
        $.spinner().start();
        if (_self.urlHermes) {
            $.ajax({
                url: _self.urlHermes,
                type: 'get',
                data: data,
                dataType: 'json',
                success: function (res) {
                    if (!res.error) {
                        _self.handlePickupResultsHermes(res.stores, res.resources, res.showMoreEnabled);
                        if (res.showMoreEnabled && res.nextStep) {
                            _self.$elementHermes.data('nextStepPickupPoint', res.nextStep);
                        }
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    }

    observeViewMoreHermes () {
        var _self = this;
        $('#pickupPointHermes').on('click', '.view-more-button-hermes', function (e) {
            _self.getStoresHermes(false);
        });
    }

    handlePickupResultsHermes (stores, resources, showMoreEnabled) {
        // Fit bounds to markers
        this.map.updateMarkersHermes(stores, resources);

        // Update the pup text list
        const $target = $('#pickupPointListHermes');
        $target.empty();
        let dataContainer = $('#pickupPointHermes');

        if ($target.length) {
            $('.map-canvas').removeClass('hide');
            let html = `<p class="dark">${resources && 'summary' in resources && resources.summary ? resources.summary : ''}</p>`;
            const selectedStoreId = $('#pickUpPointName').val();
            let labelIndex = -1;
            if (stores.length) {
                stores.map((store) => {
                    const isSelected = store.name === selectedStoreId;
                    labelIndex++;
                    html += this.renderResultHermes(store, resources, isSelected, labelIndex);
                });
                if (showMoreEnabled) {
                    html += `<div class="spacer medium"></div><div class="grid-x grid-margin-x text-center"><div class="cell"><button class="button button--secondary view-more-button-hermes ">${dataContainer.data('view-more-label')}</button><div></div>`;
                }
            }

            $target.html(html);
        }

        $(this.modal.$el).spinner().stop();
    }

    renderResultHermes (data, resources, isSelected = false, labelIndex) {
        let buttonFragment = `<p class="small dark text-right"></p>`;
        buttonFragment = `<button class="button button--primary js-choose-pickupPointHermes notranslate" data-store-id="${data.name}" data-store-sap="${data.sap}">${resources.select}</button>`;
        let labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let label = '';
        let increment = Math.floor(labelIndex >= labels.length ? labelIndex / labels.length : 0);
        let index = Math.floor(labelIndex > labels.length ? (labelIndex - Math.floor(labelIndex / labels.length).toFixed(0) * labels.length) : labelIndex);
        label = labels[index % labels.length] + (increment > 0 ? increment + '' : '');
        return `
            <div class="grid-x result ${isSelected ? 'result--selected' : ''}" data-store-id="${data.name}" data-store-sap="${data.sap}">
                <div class="cell shrink">
                    <i class="fas fa-lg fa-map-marker-alt" aria-hidden="true" role="presentation">
                        <span class="label-count small">${label}</span>
                    </i>
                </div>
                <div class="cell auto js-store-row">
                    <div class="store-details">
                        <p class="distance">
                            <span class="notranslate js-pickup-name dark">${data.name}</span>
                        </p>
                        <p>
                        <span class="notranslate js-pickup-address-row1 ">${data.street} ${data.house}</span>
                        </p>
                        <p>
                            <span class="notranslate js-pickup-city">${data.city}</span>, <span class="notranslate js-pickup-postalcode">${data.postcode}</span>
                        </p>
                    </div>
                    <div class="cell spacer small"></div>
                    <div class="cell grid-x">
                        <div class="cell small-6 align-self-middle">
                            <a target="_blank" class="uppercase fi-show-on-map-hermes dark force-hover" data-coords="${data.lat},${data.long}">${resources.showOnMap}</a>
                        </div>
                        <div class="cell small-4 text-right">
                            ${buttonFragment}
                        </div>
                    </div>
                    <div class="cell spacer"></div>
                </div>
            </div>`;
    }

    woosmapListenerInPost () {
        var _self = this;
        $('body').on('woosmap:chooseOptionInPost', function (e, selection) {
            if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                // Set active coordinates according to Google Geocoding's response
                _self.coordinates.lat = selection.geometry.location.lat;
                _self.coordinates.long = selection.geometry.location.lng;
                // Update map with current coordinates
                _self.map.updateCoordinates(_self.coordinates);
                _self.getStoresInPost();
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Woosmap failed.');
                $.spinner().stop();
            }
        });
        $('body').on('submit', '#InPost-form', function (e) {
            e.preventDefault();
        });
    }

    woosmapListenerPPL () {
        var _self = this;
        $('body').on('woosmap:chooseOptionPPL', function (e, selection) {
            if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                // Set active coordinates according to Google Geocoding's response
                _self.coordinates.lat = selection.geometry.location.lat;
                _self.coordinates.long = selection.geometry.location.lng;
                _self.queryPPL = selection.address_components[1].long_name + ', ' + selection.address_components[0].long_name;
                _self.zipcode = '';
                _self.locality = '';
                if (selection.types[0] === 'postal_code') {
                    _self.zipcode = selection.name;
                }
                if (selection.types[0] === 'locality') {
                    _self.locality = selection.name;
                }
                // Update map with current coordinates
                _self.map.updateCoordinates(_self.coordinates);
                _self.getStoresPPL();
                $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Woosmap failed.');
                $.spinner().stop();
            }
        });
        $('body').on('submit', '#PPL-form', function (e) {
            e.preventDefault();
        });
    }
    woosmapListenerCLSS () {
        var _self = this;
        $('body').on('woosmap:chooseOptionCLSS', function (e, selection) {
            if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                // Set active coordinates according to Google Geocoding's response
                _self.coordinates.lat = selection.geometry.location.lat;
                _self.coordinates.long = selection.geometry.location.lng;
                _self.queryPPL = selection.address_components[1].long_name + ', ' + selection.address_components[0].long_name;
                _self.zipcode = '';
                _self.locality = '';
                _self.addressComponent = '';

                if (selection.types[0] === 'postal_code') {
                    _self.zipcode = selection.name;
                }
                if (selection.types[0] === 'locality') {
                    _self.locality = selection.name;
                }

                if (selection.address_components.length > 0) {
                    if (_self.locality) {
                        for (let i = 0; i < selection.address_components.length; i++) {
                            let address = selection.address_components[i];
                            if (address.types[0] === 'postal_code') {
                                _self.addressComponent = address.long_name[0];
                            }
                        }
                    } else if (_self.zipcode) {
                        for (let i = 0; i < selection.address_components.length; i++) {
                            let address = selection.address_components[i];
                            if (address.types[0] === 'administrative_area_level_1') {
                                _self.addressComponent = address.long_name;
                            }
                        }
                    }
                }

                // Update map with current coordinates
                _self.map.updateCoordinates(_self.coordinates);
                _self.getStoresCLSS();
                $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Woosmap failed.');
                $.spinner().stop();
            }
        });
        $('body').on('submit', '#CLSS-form', function (e) {
            e.preventDefault();
        });
    }

    woosmapListenerDHL () {
        var _self = this;
        $('body').on('woosmap:chooseOptionDHL', function (e, selection) {
            if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                // Set active coordinates according to Google Geocoding's response
                _self.coordinates.lat = selection.geometry.location.lat;
                _self.coordinates.long = selection.geometry.location.lng;
                _self.queryDHL = selection.address_components[1].long_name + ', ' + selection.address_components[0].long_name;
                _self.zipcode = '';
                _self.locality = '';
                if (selection.types[0] === 'postal_code') {
                    _self.zipcode = selection.name;
                }
                if (selection.types[0] === 'locality') {
                    _self.locality = selection.name;
                }
                // Update map with current coordinates
                _self.map.updateCoordinates(_self.coordinates);
                _self.getStoresDHL();
                $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Woosmap failed.');
                $.spinner().stop();
            }
        });
        $('body').on('submit', '#DHL-form', function (e) {
            e.preventDefault();
        });
    }

    woosmapListenerBRT () {
        var _self = this;
        $('body').on('woosmap:chooseOptionBRT', function (e, selection) {
            if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                // Set active coordinates according to Google Geocoding's response
                _self.coordinates.lat = selection.geometry.location.lat;
                _self.coordinates.long = selection.geometry.location.lng;
                _self.queryPPL = selection.address_components[1].long_name + ', ' + selection.address_components[0].long_name;
                _self.zipcode = '';
                _self.locality = '';
                if (selection.types[0] === 'postal_code') {
                    _self.zipcode = selection.name;
                }
                if (selection.types[0] === 'locality') {
                    _self.locality = selection.name;
                }
                // Update map with current coordinates
                _self.map.updateCoordinates(_self.coordinates);
                _self.getStoresBRT(false);
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Woosmap failed.');
                $.spinner().stop();
            }
        });
        $('body').on('submit', '#BRT-form', function (e) {
            e.preventDefault();
        });
    }

    woosmapListenerDPD () {
        var _self = this;
        $('body').on('woosmap:chooseOptionDPD', function (e, selection) {
            if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                // Set active coordinates according to Google Geocoding's response
                _self.coordinates.lat = selection.geometry.location.lat;
                _self.coordinates.long = selection.geometry.location.lng;
                _self.queryDPD = selection.address_components[1].long_name + ', ' + selection.address_components[0].long_name;
                _self.zipcode = '';
                _self.locality = '';
                if (selection.types[0] === 'postal_code') {
                    _self.zipcode = selection.name;
                }
                if (selection.types[0] === 'locality') {
                    _self.locality = selection.name;
                }
                // Update map with current coordinates
                _self.map.updateCoordinates(_self.coordinates);
                _self.getStoresDPD();
                $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Woosmap failed.');
                $.spinner().stop();
            }
        });
        $('body').on('submit', '#DPD-form', function (e) {
            e.preventDefault();
        });
    }

    woosmapListenerHermes () {
        var _self = this;
        $('body').on('woosmap:chooseOptionHermes', function (e, selection) {
            if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                // Set active coordinates according to Google Geocoding's response
                _self.coordinates.lat = selection.geometry.location.lat;
                _self.coordinates.long = selection.geometry.location.lng;
                _self.queryHermes = selection.address_components[1].long_name + ', ' + selection.address_components[0].long_name;
                _self.zipcode = '';
                _self.locality = '';
                if (selection.types[0] === 'postal_code') {
                    _self.zipcode = selection.name;
                }
                if (selection.types[0] === 'locality') {
                    _self.locality = selection.name;
                }
                // Update map with current coordinates
                _self.map.updateCoordinates(_self.coordinates);
                _self.getStoresHermes();
                $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
            } else {
                // Log failure to the console as warning
                console.warn('Geocoding via Woosmap failed.');
                $.spinner().stop();
            }
        });
        $('body').on('submit', '#hermes-form', function (e) {
            e.preventDefault();
        });
    }

    woosmapListenerPudoBFF () {
        var _self = this;
        if(!this.woosmapListenerPudoBFFInitialized){
            this.woosmapListenerPudoBFFInitialized = true;

            $('body').on('woosmap:chooseOptionBPOST', function (e, selection) {
                if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                    // Set active coordinates according to Google Geocoding's response
                    _self.coordinates.lat = selection.geometry.location.lat;
                    _self.coordinates.long = selection.geometry.location.lng;
                    _self.zipcode = '';
                    _self.locality = '';
                    if (selection.types[0] === 'postal_code') {
                        _self.zipcode = selection.name;
                    }
                    if (selection.types[0] === 'locality') {
                        _self.locality = selection.name;
                    }
            
                    if (selection.address_components.length > 0) {
                        if (_self.locality) {
                            for (let i = 0; i < selection.address_components.length; i++) {
                                let address = selection.address_components[i];
                                if (address.types[0] === 'postal_code') {
                                    _self.zipcode = address.long_name[0];
                                }
                            }
                        }
                    }

                    // Update map with current coordinates
                    _self.map.updateCoordinates(_self.coordinates);
                    _self.getStoresFromBFF();
                    $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
                } else {
                    // Log failure to the console as warning
                    console.warn('Geocoding via Woosmap failed.');
                    $.spinner().stop();
                }
            });

            $('body').on('woosmap:chooseOptionPDB', function (e, selection) {
                if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                    // Set active coordinates according to Google Geocoding's response
                    _self.coordinates.lat = selection.geometry.location.lat;
                    _self.coordinates.long = selection.geometry.location.lng;
                    _self.zipcode = '';
                    _self.locality = '';

                    if (selection.types[0] === 'postal_code') {
                        _self.zipcode = selection.name;
                    }
                    if (selection.types[0] === 'locality') {
                        _self.locality = selection.name;
                    }

                    if (selection.address_components.length > 0) {
                        if (_self.locality) {
                            for (let i = 0; i < selection.address_components.length; i++) {
                                let address = selection.address_components[i];
                                if (address.types[0] === 'postal_code') {
                                    _self.zipcode = address.long_name[0];
                                }
                            }
                        }
                    }

                    // Update map with current coordinates
                    _self.map.updateCoordinates(_self.coordinates);
                    _self.serviceType = $('#pickupPointPDB').find('input[name="pickup-point-service-type"]:checked').attr('id');
                    _self.getStoresFromBFF();
                    $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
                } else {
                    // Log failure to the console as warning
                    console.warn('Geocoding via Woosmap failed.');
                    $.spinner().stop();
                }
            });

            $('body').on('woosmap:chooseOptionEVR', function (e, selection) {
                if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                    // Set active coordinates according to Google Geocoding's response
                    _self.coordinates.lat = selection.geometry.location.lat;
                    _self.coordinates.long = selection.geometry.location.lng;
                    _self.zipcode = '';
                    _self.locality = '';
                    if (selection.types[0] === 'postal_code') {
                        _self.zipcode = selection.name;
                    }

                    // Update map with current coordinates
                    _self.map.updateCoordinates(_self.coordinates);
                    _self.getStoresFromBFF();
                    $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
                } else {
                    // Log failure to the console as warning
                    console.warn('Geocoding via Woosmap failed.');
                    $.spinner().stop();
                }
            });

            $('body').on('woosmap:chooseOptionPTN', function (e, selection) {
                if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                    // Set active coordinates according to Google Geocoding's response
                    _self.coordinates.lat = selection.geometry.location.lat;
                    _self.coordinates.long = selection.geometry.location.lng;
                    _self.zipcode = '';
                    _self.locality = '';
                    if (selection.types[0] === 'postal_code') {
                        _self.zipcode = selection.name;
                    }

                    // Update map with current coordinates
                    _self.map.updateCoordinates(_self.coordinates);
                    _self.getStoresFromBFF();
                    $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
                } else {
                    $.spinner().stop();
                }
            });

            $('body').on('woosmap:chooseOptionEST', function (e, selection) {
                if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                    // Set active coordinates according to Google Geocoding's response
                    _self.coordinates.lat = selection.geometry.location.lat;
                    _self.coordinates.long = selection.geometry.location.lng;
                    _self.zipcode = '';
                    _self.locality = '';
                    if (selection.types[0] === 'postal_code') {
                        _self.zipcode = selection.name;
                    }

                    // Update map with current coordinates
                    _self.map.updateCoordinates(_self.coordinates);
                    _self.serviceType = $('#pickupPointEST').find('input[name="pickup-point-service-type"]:checked').attr('id');
                    _self.getStoresFromBFF();
                    $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
                } else {
                    $.spinner().stop();
                }
            });

            $('body').on('woosmap:chooseOptionDEL', function (e, selection) {
                if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                    // Set active coordinates according to Google Geocoding's response
                    _self.coordinates.lat = selection.geometry.location.lat;
                    _self.coordinates.long = selection.geometry.location.lng;
                    _self.zipcode = '';
                    _self.locality = '';
                    if (selection.types[0] === 'postal_code') {
                        _self.zipcode = selection.name;
                    }

                    // Update map with current coordinates
                    _self.map.updateCoordinates(_self.coordinates);
                    _self.getStoresFromBFF();
                    $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
                } else {
                    $.spinner().stop();
                }
            });

            $('body').on('woosmap:chooseOptionCTT', function (e, selection) {
                if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                    // Set active coordinates according to Google Geocoding's response
                    _self.coordinates.lat = selection.geometry.location.lat;
                    _self.coordinates.long = selection.geometry.location.lng;
                    _self.zipcode = '';
                    _self.locality = '';
                    if (selection.types[0] === 'postal_code') {
                        _self.zipcode = selection.name;
                    }

                    // Update map with current coordinates
                    _self.map.updateCoordinates(_self.coordinates);
                    _self.getStoresFromBFF();
                    $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
                } else {
                    // Log failure to the console as warning
                    console.warn('Geocoding via Woosmap failed.');
                    $.spinner().stop();
                }
            });

            $('body').on('woosmap:chooseOptionGLS', function (e, selection) {
                if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                    // Set active coordinates according to Google Geocoding's response
                    _self.coordinates.lat = selection.geometry.location.lat;
                    _self.coordinates.long = selection.geometry.location.lng;
                    _self.zipcode = '';
                    _self.locality = '';
                    if (selection.types[0] === 'postal_code') {
                        _self.zipcode = selection.name;
                    }

                    // Update map with current coordinates
                    _self.map.updateCoordinates(_self.coordinates);
                    _self.getStoresFromBFF();
                    $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
                } else {
                    $.spinner().stop();
                }
            });

            $('body').on('woosmap:chooseOptionMRE', function (e, selection) {
                if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                    // Set active coordinates according to Google Geocoding's response
                    _self.coordinates.lat = selection.geometry.location.lat;
                    _self.coordinates.long = selection.geometry.location.lng;
                    _self.zipcode = '';
                    _self.locality = '';
                    if (selection.types[0] === 'postal_code') {
                        _self.zipcode = selection.name;
                    }
                    if (selection.types[0] === 'locality') {
                        _self.locality = selection.name;
                    }

                    if (selection.address_components.length > 0) {
                        if (_self.locality) {
                            for (let i = 0; i < selection.address_components.length; i++) {
                                let address = selection.address_components[i];
                                if (address.types[0] === 'postal_code') {
                                    _self.zipcode = address.long_name[0];
                                }
                            }
                        }
                    }
                    // Update map with current coordinates
                    _self.map.updateCoordinates(_self.coordinates);
                    _self.getStoresFromBFF();
                    $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
                } else {
                    $.spinner().stop();
                }
            });

            $('body').on('woosmap:chooseOptionGLSHU', function (e, selection) {
                if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                    // Set active coordinates according to Google Geocoding's response
                    _self.coordinates.lat = selection.geometry.location.lat;
                    _self.coordinates.long = selection.geometry.location.lng;
                    _self.zipcode = '';
                    _self.locality = '';
                    if (selection.types[0] === 'postal_code') {
                        _self.zipcode = selection.name;
                    }
                    if (selection.types[0] === 'locality') {
                        _self.locality = selection.name;
                    }

                    if (selection.address_components.length > 0) {
                        if (_self.locality) {
                            for (let i = 0; i < selection.address_components.length; i++) {
                                let address = selection.address_components[i];
                                if (address.types[0] === 'postal_code') {
                                    _self.zipcode = address.long_name[0];
                                }
                            }
                        }
                    }
                    // Update map with current coordinates
                    _self.map.updateCoordinates(_self.coordinates);
                    _self.getStoresFromBFF();
                    $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
                } else {
                    $.spinner().stop();
                }
            });
            $('body').on('woosmap:chooseOptionDPD', function (e, selection) {
                if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                    // Set active coordinates according to Google Geocoding's response
                    _self.coordinates.lat = selection.geometry.location.lat;
                    _self.coordinates.long = selection.geometry.location.lng;
                    _self.zipcode = '';
                    _self.locality = '';
                    if (selection.types[0] === 'postal_code') {
                        _self.zipcode = selection.name;
                    }

                    // Update map with current coordinates
                    _self.map.updateCoordinates(_self.coordinates);
                    _self.getStoresFromBFF();
                    $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
                } else {
                    $.spinner().stop();
                }
            });
            $('body').on('woosmap:chooseOptionFAN', function (e, selection) {
                if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                    // Set active coordinates according to Google Geocoding's response
                    _self.coordinates.lat = selection.geometry.location.lat;
                    _self.coordinates.long = selection.geometry.location.lng;
                    _self.zipcode = '';
                    _self.locality = '';

                    if (selection.types[0] === 'postal_code') {
                        _self.zipcode = selection.name;
                    }
                    if (selection.types[0] === 'locality') {
                        _self.locality = selection.name;
                    }

                    if (selection.address_components.length > 0) {
                        if (_self.locality) {
                            for (let i = 0; i < selection.address_components.length; i++) {
                                let address = selection.address_components[i];
                                if (address.types[0] === 'postal_code') {
                                    _self.zipcode = address.long_name[0];
                                }
                            }
                        }
                    }

                    // Update map with current coordinates
                    _self.map.updateCoordinates(_self.coordinates);
                    _self.serviceType = $('#pickupPointFAN').find('input[name="pickup-point-service-type"]:checked').attr('id');
                    _self.getStoresFromBFF();
                    $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
                } else {
                    // Log failure to the console as warning
                    console.warn('Geocoding via Woosmap failed.');
                    $.spinner().stop();
                }
            });
            $('body').on('woosmap:chooseOptionXBS', function (e, selection) {
                if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
                    // Set active coordinates according to Google Geocoding's response
                    _self.coordinates.lat = selection.geometry.location.lat;
                    _self.coordinates.long = selection.geometry.location.lng;
                    _self.zipcode = '';
                    _self.locality = '';
                    if (selection.types[0] === 'postal_code') {
                        _self.zipcode = selection.name;
                    }

                    // Update map with current coordinates
                    _self.map.updateCoordinates(_self.coordinates);
                    _self.getStoresFromBFF();
                    $('body').trigger('storeLocator:searchWithZipCodeGeoCheckoutCity', { name: selection.name });
                } else {
                    $.spinner().stop();
                }
            });

            $('body').on('submit', '#BPOST-form, #PDB-form, #EVR-form, #PTN-form, #EST-form, #DEL-form, #GLS-form, #MRE-form, #GLSHU-form, #DPD-form, #FAN-form, #XBS-form, #CTT-form', function (e) {
                e.preventDefault();
            });
        }
    }

    // ============================
    // BFF Related Methods - start

    scrollToMapPudoBFF () {
        const mapKey = `$element${this.selectedShippingMethodType}`;
        // Show Map and scroll to it
        const $map = this[mapKey].find('#js-pickupPointMap' + this.selectedShippingMethodType);
        const $wrapper = $('#pickupPoint' + this.selectedShippingMethodType + '.pickuppoint-wrapper');
        $map.show();

        $wrapper.animate({
            scrollTop: $wrapper.get(0).scrollHeight
        });
    }

    launchPudoBFF () {
        const mapKey = `wasMapInitialized${this.selectedShippingMethodType}`;

        // Only initialize Google's map once and on-demand
        if (!this[mapKey]) {
            this.initMapPudoBFF();
        }

        // If no coordinates are set, attempt to locate user and get stores
        if (!this.hasCoordinates()) {
            this.detectLocationPickupPoint();
        } else {
            // Otherwise, just get the stores with the current information
            this.getStoresFromBFF();
        }
    }

    initMapPudoBFF () {
        var mapKey
        // Create new Google Map with target and initial center on IP-detected geolocation
        let initialCoordinates = [0, 0];
        const initialCoordinatesString = $('#pickupPoint' + this.selectedShippingMethodType + '[data-geolocation]').data('geolocation');

        if (initialCoordinatesString && initialCoordinatesString.length) {
            initialCoordinates = initialCoordinatesString.split(',');
        }
        mapKey = `$element${this.selectedShippingMethodType}`;
        this.map = new Map(this[mapKey].find('#js-pickupPointMap' + this.selectedShippingMethodType), [Number(initialCoordinates[0]), Number(initialCoordinates[1])]);
        this.map.init();

        mapKey = `wasMapInitialized${this.selectedShippingMethodType}`;
        this[mapKey] = true;
    }

    renderResultFromBFF (data, resources, isSelected = false, labelIndex) {
        let buttonFragment = `<p class="small dark text-right"></p>`;
        buttonFragment = `<button class="button button--primary js-choose-pickupPoint${this.selectedShippingMethodType} notranslate" data-store-id="${data.name}" data-store-name="${data.name}" data-store-sap="${data.sap}">${resources.select}</button>`;
        let labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
        let label = '';
        let increment = Math.floor(labelIndex >= labels.length ? labelIndex / labels.length : 0);
        let index = Math.floor(labelIndex > labels.length ? (labelIndex - Math.floor(labelIndex / labels.length).toFixed(0) * labels.length) : labelIndex);
        label = labels[index % labels.length] + (increment > 0 ? increment + '' : '');
        return `
            <div class="grid-x result ${isSelected ? 'result--selected' : ''}" data-store-id="${data.name}" data-store-sap="${data.sap}">
                <div class="cell shrink">
                    <i class="fas fa-lg fa-map-marker-alt" aria-hidden="true" role="presentation">
                        <span class="label-count small">${label}</span>
                    </i>
                </div>
                <div class="cell auto js-store-row">
                    <div class="store-details">
                        <p class="distance">
                            <span class="notranslate js-pickup-name dark">${data.name}</span>
                            <span class="margin-distance">${data.distance || ''}</span>
                        </p>
                        <p>
                        <span class="notranslate js-pickup-address-row1 ">${data.street} ${data.house}</span>
                        </p>
                        <p>
                            <span class="notranslate js-pickup-city">${data.city}</span>, <span class="notranslate js-pickup-postalcode">${data.postcode}</span>
                        </p>
                        <span class="notranslate js-pickup-servicetype hide">${data.serviceType}</span>
                    </div>
                    <div class="cell spacer small"></div>
                    <div class="cell grid-x">
                        <div class="cell small-6 align-self-middle">
                            <a target="_blank" class="uppercase fi-show-on-map-${this.selectedShippingMethodType} dark force-hover" data-coords="${data.lat},${data.long}">${resources.showOnMap}</a>
                        </div>
                        <div class="cell small-4 text-right">
                            ${buttonFragment}
                        </div>
                    </div>
                    <div class="cell spacer"></div>
                </div>
            </div>`;
    }

    fillMapModalSummary (dataContainer, resources) {
        let html = '';
        if (this.selectedShippingMethodType === 'PDB') {
            if (!this.firstSearchLaunchedPDB){
                dataContainer.find('.pickup-point-service-types').show();
                dataContainer.find('#js-pickupPointMapPDB').show();
                this.firstSearchLaunchedPDB = true;
            }
            $('#PDB-summary').text(resources?.summary || '');
        } else {
            const summary = resources?.summary || '';
            html = `<p class="strong">${summary}</p>`;
        }
        if (this.selectedShippingMethodType === 'FAN') {
            if (!this.firstSearchLaunchedFAN){
                dataContainer.find('.pickup-point-service-types').show();
                dataContainer.find('#js-pickupPointMapFAN').show();
                this.firstSearchLaunchedFAN = true;
            }
            $('#FAN-summary').text(resources?.summary || '');
        } else {
            const summary = resources?.summary || '';
            html = `<p class="strong">${summary}</p>`;
        }
        return html;
    }

    handlePickupResultsFromBFF (stores, resources, result) {
        let dataContainer = $('#pickupPoint' + this.selectedShippingMethodType);
        dataContainer.attr('data-current-step-pickup-point', result.currentStep);
        dataContainer.attr('data-next-step-pickup-point', result.nextStep);
        // Fit bounds to markers
        this.map.updateMarkersFromBFF(this.selectedShippingMethodType, stores, resources);

        // Update the pup text list
        const $target = $('#pickupPointList' + this.selectedShippingMethodType);
        $target.empty();

        if ($target.length) {
            $('.map-canvas').removeClass('hide');
            let html = this.fillMapModalSummary(dataContainer, resources);

            const selectedStoreId = $('#pickUpPointNumber').val();
            let labelIndex = -1;
            if (stores.length) {
                stores.map((store) => {
                    labelIndex++;
                    const isSelected = store.sap == selectedStoreId;
                    html += this.renderResultFromBFF(store, resources, isSelected, labelIndex);
                });
            }

             if (result.showMoreEnabled && this.selectedShippingMethodType === 'DPD') {
                 html += `<div class="spacer medium"></div><div class="grid-x result text-center"><div class="cell"><button class="button button-primary view-more-button-${this.selectedShippingMethodType}">${dataContainer.data('view-more-label')}</button><div></div>`;
             }

            $target.html(html);
        }

        $(this.modal.$el).spinner().stop();
    }

    getStoresFromBFF (viewMore = false) {
        var _self = this;
        // Data to send with the request
        let rad = 10;
        if (_self.selectedShippingMethodType) {
            let dataContainer = $('#pickupPoint' + _self.selectedShippingMethodType);
            rad = viewMore ? (dataContainer.attr('data-next-step-pickup-point') ? parseInt(dataContainer.attr('data-next-step-pickup-point')) : parseInt(dataContainer.data('base-step-pickup-point'))) : (parseInt(dataContainer.data('base-step-pickup-point')) ? parseInt(dataContainer.data('base-step-pickup-point')) : 10);
        }
        var data = {
            shippingMethodType: _self.selectedShippingMethodType,
            serviceType: _self.serviceType,
            providerId: _self.selectedShippingMethodId,
            latitude: _self.coordinates.lat.toFixed(7),
            longitude: _self.coordinates.long.toFixed(7),
            zipCode: _self.zipcode,
            maxDistance: rad
        };
        if (_self.selectedShippingMethodType === 'DPD') {
            var stepLimits = [5,10,15,20,25,50,100,200,300,500,700,999];
            var currentStepIndex = _self.currentStepIndex || 0;
            if (viewMore) {
                if (currentStepIndex < stepLimits.length - 1) {
                    currentStepIndex++;
                }
            } else {
                currentStepIndex = 0;
            }
            _self.limit = stepLimits[currentStepIndex];
            data.limit = _self.limit;
            data.maxDistance = stepLimits[0]; // maxDistance = 5 for DPD
            _self.currentStepIndex = currentStepIndex;
        }
        if (_self.selectedShippingMethodType === 'EVR' && !$('#input-text-woosmap-EVR').val()) {
            return;
        }

        $.spinner().start();
        var selectedShippingMethodUrl = _self['url' + _self.selectedShippingMethodType];
        if (selectedShippingMethodUrl) {
            $.ajax({
                url: selectedShippingMethodUrl,
                type: 'get',
                data: data,
                dataType: 'json',
                success: function (res) {
                    if (!res.error) {
                        _self.handlePickupResultsFromBFF(res.stores, res.resources, res);
                    }
                },
                error: function (res) {
                    $('#pickupPointList' + _self.selectedShippingMethodType).empty();
                    let dataContainer = $('#pickupPoint' + _self.selectedShippingMethodType);
                    _self.fillMapModalSummary(dataContainer, res?.responseJSON?.resources);
                    _self.map.updateMarkersFromBFF(this.selectedShippingMethodType, [], null);
                    $.spinner().stop();
                }
            });
        }
    }

    // BFF Related Methods - end
    // ============================
}

const pickupPoint = new PickupPoint();
export default pickupPoint;
